//Se importan los types de cada acción para usar los que se requieran
import { types } from "../types/types";
import { store } from "../store/store";
//Libreria para el uso de alertas
import Swal from "sweetalert2";
import axios from "axios";
import { successAlert, errorAlert, getIP } from "./ui";
import * as moment from "moment";
import "moment/locale/es";
import "moment-timezone";
import { getDateCorregidoZonaHoraria } from "./actionsTime";
import { logUpdateDataPatient } from "./doctorLog";
import { obtener_medicamentos_controlados, obtener_medicamentos_nocontrolados, obtener_ordenes, obtener_procedimientos } from "./record/chile/saverecord/order-prescription";
import { generatePdfMedicinesCL } from "./record/chile/pdf-medicines-cl";
import { generatePdfOrdersCL } from "./record/chile/pdf-orders-cl";
import { generatePdfProceduresCL } from "./record/chile/pdf-procedures-cl";

moment.locale("es");

const returnDates = (values) => {
  const timeSchedule = new Date(values.timestamp).toLocaleString("en-ES", {
    timeZone: values.timeZone,
  });

  const dateSchedule = moment(timeSchedule)
    .locale("es")
    .format("dddd, D MMMM YYYY");

  const hourStartSchedule = moment(timeSchedule).locale("es").format("h:mma");

  const timeScheduleEnd = new Date(timeSchedule);
  // timeScheduleEnd.setMinutes(timeScheduleEnd.getMinutes() + values.timeConsult);
  timeScheduleEnd.setMinutes(timeScheduleEnd.getMinutes() + values.serviceDuration);

  const hourEndSchedule = moment(timeScheduleEnd).locale("es").format("h:mma");

  return { dateSchedule, hourStartSchedule, hourEndSchedule };
};

//Método para agregar la ficha consumiendo consumiendo la data de Schedule y Patient
// export const addRecordFromCitasAndUpdate = (values, valuesPatient) => {
//   let data = {
//     createDate: values.createDate,
//     patientAddress: values.patientAddress.trim().toUpperCase(),
//     patientAge: values.patientAge,
//     patientBirth: values.patientBirth,
//     patientCity: values.patientCity,
//     patientCityId: values.patientCityId,
//     patientCivilState: values.patientCivilState,
//     patientContactEmail: values.patientContactEmail.trim(),
//     patientContactName: values.patientContactName.trim().toUpperCase(),
//     patientContactPhone: values.patientContactPhone.trim(),
//     patientDNI: values.patientDNI.trim().toUpperCase(),
//     patientDNITypeCode: values.patientDNITypeCode,
//     patientDNITypeName: values.patientDNITypeName,
//     patientEducation: values.patientEducation,
//     patientEmail: values.patientEmail.trim(),
//     patientGender: values.patientGender,
//     patientNameFirst: values.patientNameFirst,
//     patientNameFirstLastName: values.patientNameFirstLastName,
//     patientNameSecond: values.patientNameSecond,
//     patientNameSecondLastName: values.patientNameSecondLastName,
//     patientNameSocial: values.patientNameSocial,
//     patientNationality: values.patientNationality,
//     patientOccupation: values.patientOccupation.trim().toUpperCase(),
//     patientPhone: values.patientPhone.trim(),
//     patientPhoneCode: values.patientPhoneCode.trim(),
//     patientPhoneComplete: values.patientPhoneComplete.trim(),
//     patientPlanMedicalCode: values.patientPlanMedicalCode,
//     patientPlanMedicalName: values.patientPlanMedicalName,
//     patientRegion: values.patientRegion,
//     patientRegionId: values.patientRegionId,
//     patientResidenceCountryId: values.patientResidenceCountryId,
//     patientResidenceCountry: values.patientResidenceCountry,
//   };

//   let dataAttention = {
//     reasonConsultation: values.reasonConsultation,
//     physicalExam: values.physicalExam,
//     past: values.past,
//     anamnesis: values.anamnesis,
//     diagnosis: values.diagnosis,
//     medicines: values.medicinesPatient,
//     medicalOrders: values.medicalOrders,
//     medicalOrderDetail: values.medicalOrderDetail,
//     medicalProcedures: values.medicalProcedures,
//     nutritionalIndication: values.nutritionalIndication,
//     patientHeight: values.patientHeight,
//     patientWeight: values.patientWeight,
//     imc:
//       values.patientHeight !== "" && values.patientWeight !== ""
//         ? values.patientWeight / (values.patientHeight * values.patientHeight)
//         : "",
//     resume: values.resume,
//     medicalLicense: values.medicalLicense,
//     tratNdias: values.tratNdias,
//     fechaInicioReposo: values.fechaInicioReposo,
//     fechaFinReposo: values.fechaFinReposo,
//     recoverability: values.recoverability,
//     dateReturn: values.dateReturn,
//     days: values.nextControl,
//     dateControl: values.dateControl,
//     derivation: values.checked,
//     descriptionDerivation: values.descriptionDerivation,
//     folioLicencia: values.folioLicencia,
//     idLicencia: values.payOrder,
//   };

//   return async (dispatch) => {
//     ///////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBEN EMITIR RECETAS, ÓRDENES MÉDICAS O PROCEDIMIENTO MÉDICOS /////////////////////////////////////////////

//     if (values.serviceCode === "61CL") {
//       saveDataRecordMedicines(values, data, dataAttention, valuesPatient, dispatch);
//     } else saveDataRecord(values, data, dataAttention, valuesPatient, dispatch);

//     if (
//       dataAttention.medicines.length > 0 ||
//       dataAttention.medicalOrders.length > 0 ||
//       dataAttention.medicalProcedures.length > 0
//     ) {
//       let idDoctorRecemed;
//       let idPatientRecemed;

//       dispatch(setShowAlertMedicineTrue(true));

//       const professionalRut =
//         values.professionalDNI === "48198217-0"
//           ? "24043480-6"
//           : values.professionalDNI;

//       getIDDoctor(
//         professionalRut,
//         values.patientDNI,
//         values.timestamp,
//         values.timeZone
//       ).then((response) => {
//         idDoctorRecemed = response;

//         getIDPaciente(
//           data,
//           professionalRut,
//           values.timestamp,
//           values.timeZone
//         ).then((response) => {
//           idPatientRecemed = response;

//           if (dataAttention.medicines.length > 0) {
//             createReceta(
//               data.patientPlanMedicalCode,
//               idDoctorRecemed,
//               idPatientRecemed,
//               dataAttention.medicines,
//               false,
//               professionalRut,
//               values.professionalNameComplete,
//               values.patientDNI,
//               values.patientName,
//               values.patientLastName,
//               dispatch
//             ).then((responseReceta) => {
//               if (responseReceta.status === 200) {
//                 ///////////////////////////////////////////// INICIO PROCEDIMIENTO RECEMED /////////////////////////////////////////////
//                 createOrderAndProcedure(
//                   dataAttention,
//                   idDoctorRecemed,
//                   idPatientRecemed,
//                   values,
//                   data,
//                   valuesPatient,
//                   dispatch,
//                   responseReceta
//                 );
//                 ///////////////////////////////////////////// FIN PROCEDIMIENTO RECEMED ////////////////////////////////////////////////
//               }
//             });
//           } else {
//             ///////////////////////////////////////////// INICIO PROCEDIMIENTO Y ORDEN RECEMED ////////////////////////////////////////////////
//             createOrderAndProcedure(
//               dataAttention,
//               idDoctorRecemed,
//               idPatientRecemed,
//               values,
//               data,
//               valuesPatient,
//               dispatch
//             );
//             ///////////////////////////////////////////// FIN PROCEDIMIENTO Y ORDEN RECEMED ////////////////////////////////////////////////
//           }
//         });
//       });
//     } else {
//       resumeAttentionCL(values);
//     }
//   };
// };

export const addRecordFromCitasAndUpdate = (values, valuesPatient) => {
  let data = {
    createDate: values.createDate,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientAge: values.patientAge,
    patientBirth: values.patientBirth,
    patientCity: values.patientCity,
    patientCityId: values.patientCityId,
    patientCivilState: values.patientCivilState,
    patientContactEmail: values.patientContactEmail.trim(),
    patientContactName: values.patientContactName.trim().toUpperCase(),
    patientContactPhone: values.patientContactPhone.trim(),
    patientDNI: values.patientDNI.trim().toUpperCase(),
    patientDNITypeCode: values.patientDNITypeCode,
    patientDNITypeName: values.patientDNITypeName,
    patientEducation: values.patientEducation,
    patientEmail: values.patientEmail.trim(),
    patientGender: values.patientGender,
    patientNameFirst: values.patientNameFirst,
    patientNameFirstLastName: values.patientNameFirstLastName,
    patientNameSecond: values.patientNameSecond,
    patientNameSecondLastName: values.patientNameSecondLastName,
    patientNameSocial: values.patientNameSocial,
    patientNationality: values.patientNationality,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientPhone: values.patientPhone.trim(),
    patientPhoneCode: values.patientPhoneCode.trim(),
    patientPhoneComplete: values.patientPhoneComplete.trim(),
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientRegion: values.patientRegion,
    patientRegionId: values.patientRegionId,
    patientResidenceCountryId: values.patientResidenceCountryId,
    patientResidenceCountry: values.patientResidenceCountry,
  };

  let dataAttention = {
    reasonConsultation: values.reasonConsultation,
    physicalExam: values.physicalExam,
    past: values.past,
    anamnesis: values.anamnesis,
    diagnosis: values.diagnosis,
    medicines: values.medicinesPatient,
    medicalOrders: values.medicalOrders,
    medicalOrderDetail: values.medicalOrderDetail,
    medicalProcedures: values.medicalProcedures,
    nutritionalIndication: values.nutritionalIndication,
    patientHeight: values.patientHeight,
    patientWeight: values.patientWeight,
    imc:
      values.patientHeight !== "" && values.patientWeight !== ""
        ? values.patientWeight / (values.patientHeight * values.patientHeight)
        : "",
    resume: values.resume,
    medicalLicense: values.medicalLicense,
    medicalLicenseType: values.medicalLicenseType,
    tratNdias: values.tratNdias,
    fechaInicioReposo: values.fechaInicioReposo,
    fechaFinReposo: values.fechaFinReposo,
    recoverability: values.recoverability,
    dateReturn: values.dateReturn,
    days: values.nextControl,
    dateControl: values.dateControl,
    derivation: values.checked,
    descriptionDerivation: values.descriptionDerivation,
    folioLicencia: values.folioLicencia,
    idLicencia: values.payOrder,
    diagnosisRelated: values.diagnosisRelated,
    urgencyReferral: values.urgencyReferral,
    urgencyDescription: values.urgencyDescription,
    suicideRisk: values.suicideRisk,
    suicideRiskDescription: values.suicideRiskDescription,
    ratingScale: values.ratingScale,
    riskScore: values.riskScore
  };

  return async (dispatch) => {

    if (values.serviceCode === "61CL") {
      saveDataRecordMedicines(values, data, dataAttention, valuesPatient, dispatch);
    } else saveDataRecord(values, data, dataAttention, valuesPatient, dispatch);

    const professionalRut = values.professionalDNI;

    const patientDNI = values.patientDNI;
    const timestamp = values.timestamp;
    const timeZone = values.timeZone;

    const ordenes = dataAttention.medicalOrders;
    const descripcionOrdenes = dataAttention.medicalOrderDetail;
    const procedimientos = dataAttention.medicalProcedures;
    const procedures = `${dataAttention.diagnosis.label}\n\n${procedimientos}`;

    const medicamentos = dataAttention.medicines;

    const profName = values.professionalNameComplete;
    const patientRut = values.patientDNI;
    const patientName = values.patientName;
    const patientLastName = values.patientLastName;

    // Se valida si la company tiene el permiso para consumir Recemed o generar PDF
    const reduxState = store.getState().company;
    const { permissionRecemed } = reduxState.permissionsIntegrations;

    if (permissionRecemed) {
      const [idDoctor, idPaciente] = await Promise.all([
        getIDDoctor(professionalRut, patientDNI, timestamp, timeZone),
        getIDPaciente(data, professionalRut, timestamp, timeZone)
      ]);

      // Crear promesas para obtener órdenes, procedimientos y medicamentos
      const promesaOrdenes = ordenes.length > 0 ?
        await obtener_ordenes(
          idDoctor,
          idPaciente,
          ordenes,
          descripcionOrdenes,
          professionalRut,
          profName,
          patientRut,
          patientName,
          patientLastName)
        : null;

      const promesaProcedimientos = procedimientos.length > 0 ?
        await obtener_procedimientos(
          idDoctor,
          idPaciente,
          procedures,
          professionalRut,
          profName,
          patientRut,
          patientName,
          patientLastName)
        : null;

      // Separar medicamentos controlados y no controlados
      const medicamentosControlados = medicamentos.filter(medicamento => medicamento.control === true);
      const medicamentosNoControlados = medicamentos.filter(medicamento => medicamento.control !== true);

      // Realizar peticiones para medicamentos controlados
      const peticionesMedicamentosControlados = medicamentosControlados.map(medicamento => obtener_medicamentos_controlados(
        data.patientPlanMedicalCode,
        idDoctor,
        idPaciente,
        medicamento,
        false,
        professionalRut,
        values.professionalNameComplete,
        values.patientDNI,
        values.patientName,
        values.patientLastName
      ));
      const resultadosMedicamentosControlados = medicamentosControlados.length === 0 ? null : await Promise.all(peticionesMedicamentosControlados);

      // Realizar una única petición para medicamentos no controlados
      const resultadosMedicamentosNoControlados = medicamentosNoControlados.length === 0 ? null : await obtener_medicamentos_nocontrolados(
        data.patientPlanMedicalCode,
        idDoctor,
        idPaciente,
        medicamentosNoControlados,
        false,
        professionalRut,
        values.professionalNameComplete,
        values.patientDNI,
        values.patientName,
        values.patientLastName
      );

      if (promesaOrdenes) {
        values.responseOrdenes = promesaOrdenes;
      }
      if (promesaProcedimientos) {
        values.responseProcedimientos = promesaProcedimientos;
      }
      if (resultadosMedicamentosControlados) {
        values.medicamentosControlados = resultadosMedicamentosControlados;
        values.medicamentosControladosReq = medicamentosControlados;
      }
      if (resultadosMedicamentosNoControlados) {
        values.medicamentosNoControlados = resultadosMedicamentosNoControlados;
        values.medicamentosNoControladosReq = medicamentosNoControlados;
      }
    }

    resumeAttentionCL(values);
  }
}

function resumeAttentionCL(values) {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;
  const urlServer = reduxState.companyInstance.urlServer;

  const fullNamePatient = values.patientName;
  const fullLastNamePatient = values.patientLastName;

  const { dateSchedule, hourStartSchedule, hourEndSchedule } =
    returnDates(values);

  const msgDiagnosticoNutricional =
    values.patientIMC < 18.5
      ? "Peso Insuficiente"
      : values.patientIMC >= 18.5 && values.patientIMC < 25
        ? "Peso Saludable"
        : values.patientIMC >= 25 && values.patientIMC < 30
          ? "Sobrepeso"
          : "Obesidad";
  const nutritionalIndication =
    values.nutritionalIndication !== ""
      ? `Información Nutricional: ${values.nutritionalIndication}`
      : "";

  const resumeAttention =
    values.patientIMC !== ""
      ? `${values.resume}
  Peso: ${values.patientWeight} |
  Altura: ${values.patientHeight} |
  IMC: ${values.patientIMC} |
  Diagnóstico Nutricional: ${msgDiagnosticoNutricional} |
  ${nutritionalIndication}`
      : values.nutritionalIndication !== ""
        ? `${values.resume} |
  ${nutritionalIndication}`
        : values.resume;

  let arrayDiagnosisRelated = values.diagnosisRelated.length > 0 ? values.diagnosisRelated.map(objeto => objeto.label) : null;

  let dataResume = {
    email: values.patientEmail,
    patientDNI: values.patientDNI,
    patientName: `${fullNamePatient} ${fullLastNamePatient}`,
    professionalDNI: values.professionalDNI,
    professionalName: values.professionalNameComplete,
    specialtyName: values.typeConsult,
    date: dateSchedule,
    timeStart: hourStartSchedule,
    timeEnd: hourEndSchedule,
    diagnosis: values.diagnosis.label,
    diagnosisRelated: arrayDiagnosisRelated,
    resume: resumeAttention,
    timeZone: values.timeZone,
    files: values.files,
    scheduleDiscount: values.scheduleDiscount,
    scheduleDiscountCode: values.scheduleDiscountCode,
    respOrder: values.responseOrdenes,
    respRecetaControlada: values.medicamentosControlados,
    recetasControladas: values.medicamentosControladosReq,
    respRecetaNoControlada: values.medicamentosNoControlados,
    recetasNoControladas: values.medicamentosNoControladosReq,
    notify: values.notify,
    idDocument: values.idDocument,
    timestamp: values.timestamp
  };

  if (dataResume.respOrder && values.notify) {
    const dataToExamed = {
      RUT_PAC: values.patientDNI,
      DNI_PAC: "",
      NOM_PAC: values.patientName,
      APE_PAC: values.patientLastName,
      Sexo: values.patientGender,
      ID_NAC: values.patientNationality,
      Fecha_Nac: values.patientBirth,
      Direccion: values.patientAddress,
      Telefono: values.patientPhone,
      Correo: values.patientEmail,
      ID_COM: values.patientCity,
      OBS: values.medicalOrderDetail,
      ID_HOST_PROFESIONAL: values.host,
      RUT_Profesional: values.professionalDNI,
      Nombre_Profesional: values.professionalName,
      Apellido_Profesional: values.professionalLastName,
      Examenes: values.medicalOrders,
      idDocument: values.idDocument,
      timestamp: values.timestamp
    };

    dataResume = { ...dataResume, ...dataToExamed }
  }

  const responseOrdenes = values.responseOrdenes;
  const responseProcedimientos = values.responseProcedimientos;

  const resRecetasControladas = values.medicamentosControlados;
  const recetasControladas = values.medicamentosControladosReq;
  const responseRecetasControladas = [];

  if (resRecetasControladas) {
    resRecetasControladas.forEach((receta, ix) => {
      const recetaDesc = recetasControladas[ix];
      responseRecetasControladas.push({
        prescription: receta,
        prescriptionName: {
          id: recetaDesc.id,
          name: recetaDesc.name.label
        }
      })
    });
  }

  const responseRecetasNoControladas = values.medicamentosNoControlados;

  dataResume.resControl = responseRecetasControladas;

  const updateData = Object.assign(
    {},
    responseOrdenes && { exams: responseOrdenes },
    responseProcedimientos && { procedures: responseProcedimientos },
    resRecetasControladas && { controlledPrescriptions: responseRecetasControladas },
    responseRecetasNoControladas && { nonControlledPrescriptions: responseRecetasNoControladas }
  );

  // Filtrar para eliminar propiedades con valores null o undefined
  const filteredUpdateData = Object.fromEntries(
    Object.entries(updateData).filter(([_, value]) => value != null)
  );

  // const refSchedule = db.collection("schedule_chile").doc(values.idDocument);
  const refRecord = db.collection("attention")
    .doc(values.scheduleCountry.replaceAll(" ", "").toLowerCase())
    .collection(values.patientDNI)
    .doc(values.timestamp.toString());

  // Realizar la actualización solo si hay algo que actualizar
  if (Object.keys(filteredUpdateData).length > 0) {
    const batch = firebase.firestore().batch();
    batch.update(refRecord, { ...filteredUpdateData });
    batch.commit();
  }

  const { medicinesPatient } = values;
  const products = medicinesPatient.map(objeto => ({ productId: objeto.name.id }));

  const userData = {
    firstName: values.patientName,
    lastName: values.patientLastName,
    email: values.patientEmail,
    rut: values.patientDNI,
    phoneNumber: `${values.patientPhoneCode}${values.patientPhone}`,
    streetName: values.patientAddress,
    streetNumber: "",
    commune: values.patientCity,
    region: values.patientRegion,
    details: ""
  };

  dataResume.products = products;
  dataResume.userData = userData;

  // Enqueu Task Resume Attention
  axios.post(`${urlServer}/mails/resumeEnqueueTask`, dataResume);
}

// Método para guardar la ficha médica
export const saveDataRecord = (
  values,
  data,
  dataAttention,
  valuesPatient,
  dispatch
) => {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;
  const urlServer = reduxState.companyInstance.urlServer;

  /////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBE ACTUALIZAR ALGÚN CAMPO DEL PACIENTE EN PATIENT ////////////////////////////////////////////

  const fullNamePatient = values.patientName;
  const fullLastNamePatient = values.patientLastName;

  const firstName = values.patientNameFirst;
  const secondName = values.patientNameSecond;
  const firstLastName = values.patientNameFirstLastName;
  const secondLastName = values.patientNameSecondLastName;

  const patientInfoOld = valuesPatient.patient;

  const fullNameLastNameOld = `${patientInfoOld.patientNameFirst
    .trim()
    .toUpperCase()} ${patientInfoOld.patientNameSecond
      .trim()
      .toUpperCase()} ${patientInfoOld.patientNameFirstLastName
        .trim()
        .toUpperCase()} ${patientInfoOld.patientNameSecondLastName
          .trim()
          .toUpperCase()}`.replaceAll("  ", " ");

  const fullNameLastNameActual = `${fullNamePatient
    .trim()
    .toUpperCase()} ${fullLastNamePatient.trim().toUpperCase()}`;

  const patientInfoActual = {
    dateUpdate: new Date(),
    patientAddress: values.patientAddress,
    patientBirth: values.patientBirth,
    patientCity: values.patientCity,
    patientCityId: values.patientCityId,
    patientCivilState: values.patientCivilState,
    patientContactEmail: values.patientContactEmail,
    patientContactPhone: values.patientContactPhone,
    patientDNI: values.patientDNI,
    patientEducation: values.patientEducation,
    patientEmail: values.patientEmail,
    patientGender: values.patientGender,
    patientContactName: values.patientContactName,
    patientNameFirst: firstName,
    patientNameFirstLastName: firstLastName,
    patientNameSecond: secondName,
    patientNameSecondLastName: secondLastName,
    patientNameSocial: values.patientNameSocial,
    patientNationality: values.patientNationality,
    patientOccupation: values.patientOccupation,
    patientPhone: values.patientPhone,
    patientPhoneCode: values.patientPhoneCode,
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientRegion: values.patientRegion,
    patientRegionId: values.patientRegionId,
    patientResidenceCountry: values.patientResidenceCountry,
    patientResidenceCountryId: values.patientResidenceCountryId,
  };

  if (
    firstName !== patientInfoOld.patientNameFirst.trim().toUpperCase() ||
    secondName !== patientInfoOld.patientNameSecond.trim().toUpperCase() ||
    firstLastName !==
    patientInfoOld.patientNameFirstLastName.trim().toUpperCase() ||
    secondLastName !==
    patientInfoOld.patientNameSecondLastName.trim().toUpperCase() ||
    values.patientAddress !==
    patientInfoOld.patientAddress.trim().toUpperCase() ||
    values.patientBirthDate !== patientInfoOld.patientBirth ||
    values.patientCity !== patientInfoOld.patientCity ||
    values.patientCivilState !== patientInfoOld.patientCivilState ||
    values.patientContactEmail !== patientInfoOld.patientContactEmail ||
    values.patientContactName !== patientInfoOld.patientContactName ||
    values.patientContactPhone !== patientInfoOld.patientContactPhone ||
    values.patientResidenceCountry !== patientInfoOld.patientResidenceCountry ||
    values.patientEducation !== patientInfoOld.patientEducation ||
    values.patientEmail !== patientInfoOld.patientEmail ||
    values.patientGender !== patientInfoOld.patientGender ||
    values.patientPlanMedicalName !== patientInfoOld.patientPlanMedicalName ||
    values.patientNameSocial !== patientInfoOld.patientNameSocial ||
    values.patientNationality !== patientInfoOld.patientNationality ||
    values.patientOccupation !== patientInfoOld.patientOccupation ||
    values.patientPhone !== patientInfoOld.patientPhone ||
    values.patientPhoneCode !== patientInfoOld.patientPhoneCode ||
    values.patientRegion !== patientInfoOld.patientRegion
  ) {
    db.collection("patient_ecuador")
      .doc(values.patientDNI)
      .update({ ...patientInfoActual });
  }

  /////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBE ACTUALIZAR ALGÚN CAMPO DEL PACIENTE EN PATIENT ////////////////////////////////////////////

  db.collection("professional")
    .where("dni", "==", values.professionalDNI)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const patientsProfessional = doc.data().patient;
        let patientFind = "";

        if (patientsProfessional !== undefined) {
          patientFind = patientsProfessional.find(
            (patient) =>
              patient.patientDNI.trim().toUpperCase() ===
              data.patientDNI.trim().toUpperCase()
          );
        }

        if (patientFind !== "") {
          db.collection("professional")
            .doc(doc.data().uid)
            .update({
              patient: firebase.firestore.FieldValue.arrayUnion({
                patientDNI: data.patientDNI,
                patientName: `${fullNamePatient.trim()} ${fullLastNamePatient.trim()}`,
              }),
            });
        } else {
          if (fullNameLastNameActual !== fullNameLastNameOld) {
            db.collection("professional")
              .doc(doc.data().uid)
              .update({
                patient: firebase.firestore.FieldValue.arrayRemove(patientFind),
              })
              .then((res) => {
                db.collection("professional")
                  .doc(doc.data().uid)
                  .update({
                    patient: firebase.firestore.FieldValue.arrayUnion({
                      patientDNI: values.patientDNI.trim().toUpperCase(),
                      patientName: fullNameLastNameActual,
                    }),
                  });
              });
          }
        }
      });
    });

  // const docRefSchedule = db.collection("schedule_ecuador").doc(values.idDocument);

  // docRefSchedule
  //   .get()
  //   .then((doc) => {
  //     if (doc.exists) {
  //       if (
  //         doc.data().folio === "" &&
  //         doc.data().patientPlanMedicalName === "FONASA" &&
  //         doc.data().id_atencion !== "" &&
  //         doc.data().hash !== ""
  //       ) {
  //         const dataPreBono = {
  //           id_atencion: doc.data().id_atencion,
  //           hash: doc.data().hash,
  //         };

  //         axios
  //           .post(`${urlServer}/fonasa/activacion`, dataPreBono)
  //           .then(async (response) => {
  //             console.log(response);

  //             if (response.data.response.data.validarResponse !== undefined) {
  //               if (response.data.response.data.validarResponse.estado === 1) {
  //                 getIP().then((responseIP) => {
  //                   enviarLogDoctorBonoActivation(
  //                     "[Medipass Fonasa] Bonus Activation",
  //                     values.professionalDNI,
  //                     values.professionalNameComplete,
  //                     values.patientDNI,
  //                     values.patientName,
  //                     values.patientLastName,
  //                     response.data.response.data.bonos.info[0],
  //                     responseIP.data
  //                   );
  //                 });

  //                 const dataFonasa = {
  //                   rutPatient: values.patientDNI,
  //                   folioInfo: response.data.response.data.bonos.info[0].folio,
  //                   codPrestacion: values.typeConsultCodeAlternative,
  //                 };

  //                 const folioRef = db
  //                   .collection("schedule_chile")
  //                   .doc(values.idDocument);

  //                 // Set the Folio
  //                 try {
  //                   await folioRef.update({
  //                     folio: response.data.response.data.bonos.info[0].folio,
  //                   });
  //                   console.log("Document successfully updated!");
  //                 } catch (error) {
  //                   // The document probably doesn't exist.
  //                   console.error("Error updating document: ", error);
  //                 }

  //                 const dataBono = {
  //                   bonos: [
  //                     {
  //                       id: doc.data().id_bono,
  //                     },
  //                   ],
  //                 };

  //                 axios
  //                   .post(`${urlServer}/fonasa/imphtml`, dataBono)
  //                   .then(async (response) => {
  //                     console.log("responseBono", response)
  //                     sendEmailBono(
  //                       doc.data().patientEmail,
  //                       doc.data().patientName,
  //                       response.data.medioPago.html
  //                     );
  //                   });

  //                 // EMISION A FONASA
  //                 issueFonasa(values, dataFonasa);
  //               }
  //             } else {
  //               // errorAlert('No se pudo Activar el Bono, notifiquelo a Atención al Cliente');
  //               getIP().then((responseIP) => {
  //                 enviarLogDoctorErrorBonoActivation(
  //                   "[Medipass Fonasa] Bonus Activation Failed",
  //                   response.data.mensaje,
  //                   values.professionalDNI,
  //                   values.professionalNameComplete,
  //                   values.patientDNI,
  //                   values.patientName,
  //                   values.patientLastName,
  //                   values.id_atencion,
  //                   responseIP.data
  //                 );
  //               });
  //             }
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //             getIP().then((response) => {
  //               enviarLogDoctorErrorBonoActivation(
  //                 "[Medipass Fonasa] Bonus Activation Failed",
  //                 response.data.mensaje,
  //                 values.professionalDNI,
  //                 values.professionalNameComplete,
  //                 values.patientDNI,
  //                 values.patientName,
  //                 values.patientLastName,
  //                 values.id_atencion,
  //                 response.data
  //               );
  //             });
  //           });
  //       } else {
  //         if (doc.data().patientPlanMedicalName === "FONASA" &&
  //           doc.data().id_atencion !== "" &&
  //           doc.data().hash !== "") {

  //           const dataFonasa = {
  //             rutPatient: values.patientDNI,
  //             folioInfo: doc.data().folio,
  //             codPrestacion: values.typeConsultCodeAlternative
  //           };

  //           // EMISION A FONASA
  //           issueFonasa(values, dataFonasa);
  //         }
  //       }
  //     } else {
  //       // doc.data() will be undefined in this case
  //       console.log("No such document!");
  //     }
  //   })
  //   .catch((error) => {
  //     console.log("Error getting document:", error);
  //   });

  dispatch(setShowAlertMedicineTrue(false));

  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////

  db.collection("attention")
    .doc(values.scheduleCountry.toLowerCase())
    .collection(values.patientDNI)
    .doc(values.timestamp.toString())
    .update({
      patientInfo: data,
      attention: dataAttention,
      pathFiles: values.pathFiles,
      timeConsult: values.timeConsult,
      notify: values.notify
    })
    .then((docRef) => {
      if (values.checked.length > 0 || values.dateControl !== "") {
        const deriv = [];
        if (values.checked !== "") {
          values.checked.forEach((value) => {
            deriv.push(value.label);
          });
        }

        db.collection("referrals")
          .doc(values.idDocument)
          .set({
            derivaciones: deriv,
            idDocument: values.idDocument,
            patientEmail: values.patientEmail,
            patientName: fullNamePatient,
            patientLastName: fullLastNamePatient,
            patientPhone: `${values.patientPhoneCode}${values.patientPhone}`,
            patientDNI: values.patientDNI,
            professionalName: values.professionalNameComplete,
            professionalDNI: values.professionalDNI,
            state:
              values.checked.length === 0
                ? ""
                : deriv.includes("No necesita derivación")
                  ? ""
                  : "POR CONTACTAR",
            controlDate: values.dateControl,
            controlState: values.dateControl === "" ? "" : "POR CONTACTAR",
            timeStartAttention: values.startTimeTimestamp,
            description: values.descriptionDerivation,
          })
          .then(() => {
            let dateStringControl = null;
            if (values.dateControl !== "") {
              dateStringControl = moment(values.dateControl)
                .locale("es")
                .format('DD [de] MMMM YYYY')
            }
            // let arrayDiagnosisRelated = values.diagnosisRelated.length > 0 ? values.diagnosisRelated.map(objeto => objeto.label) : null;

            const dataReminder = {
              email: values.patientEmail,
              patientName: `${fullNamePatient} ${fullLastNamePatient}`,
              professionalName: values.professionalNameComplete,
              control: dateStringControl,
              referral: deriv.length > 0 ? deriv : null,
              referralDescription: values.descriptionDerivation !== "" ? values.descriptionDerivation : null,
              // diagnosis: values.diagnosis.label,
              // diagnosisRelated: arrayDiagnosisRelated,
              diagnosis: null,
              diagnosisRelated: null,
              service: values.typeConsult
            };

            // Encolar las tareas de notificación de Control o Derivación
            axios.post(
              `${urlServer}/mails/referralsControlEnqueueTask`,
              dataReminder
            );
          })
          .catch((error) => {
            console.log("Error set Referrral", error);
            getIP().then((response) => {
              enviarLogErrorDoctorAddDerivations(
                "[Doctor] Add Derivations",
                error.toString(),
                values.professionalDNI,
                values.professionalNameComplete,
                values.patientDNI,
                fullNamePatient,
                fullLastNamePatient,
                values.idDocument,
                response.data
              );
            });
          });
      }

      // Utilizando el método map para obtener un nuevo array con solo los valores de la propiedad "label"
      let arrayDiagnosisRelated = values.diagnosisRelated.length > 0 ? values.diagnosisRelated.map(objeto => objeto.label) : null;
      if (values.urgencyReferral) {

        const dataReferralUrgency = {
          email: values.patientEmail,
          patientDNI: values.patientDNI,
          patientName: `${fullNamePatient} ${fullLastNamePatient}`,
          professionalDNI: values.professionalDNI,
          professionalName: values.professionalNameComplete,
          urgencyDescription: values.urgencyDescription,
          diagnosis: values.diagnosis.label,
          diagnosisRelated: arrayDiagnosisRelated,
        };

        axios.post(
          `${urlServer}/mails/referralsUrgencyEnqueueTask`,
          dataReferralUrgency
        );
      }

      db.collection("schedule_ecuador").doc(values.idDocument).update({
        timeEnd: new Date(),
        notify: values.notify
      }).then(() => {

      }).catch((errorTime) => {
        db.collection("errorTimeEnd")
          .add({
            log_date: new Date(),
            error: errorTime.toString(),
            professionalDNI: values.professionalDNI,
            patientDNI: values.patientDNI,
            idDocument: values.idDocument,
          })
      });
    })
    .catch((error) => {
      errorAlert(
        "No se pudo agregar la Ficha con Éxito, notificarlo al Área de TI"
      );
      getIP().then((response) => {
        enviarLogDoctorErrorAddRecord(
          types.doctorAddNewRecord,
          error.toString(),
          values.professionalRut,
          values.professionalName,
          values.patientName,
          values.patientLastName,
          values.idDocument,
          response.data
        );
      });
    });

  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////
};

// Método para guardar la ficha médica de transcripción de recetas
export const saveDataRecordMedicines = (
  values,
  data,
  dataAttention,
  valuesPatient,
  dispatch
) => {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;

  const fullNamePatient = values.patientName;
  const fullLastNamePatient = values.patientLastName;

  const patientInfoOld = valuesPatient.patient;

  const fullNameLastNameOld = `${patientInfoOld.patientNameFirst
    .trim()
    .toUpperCase()} ${patientInfoOld.patientNameSecond
      .trim()
      .toUpperCase()} ${patientInfoOld.patientNameFirstLastName
        .trim()
        .toUpperCase()} ${patientInfoOld.patientNameSecondLastName
          .trim()
          .toUpperCase()}`.replaceAll("  ", " ");

  const fullNameLastNameActual = `${fullNamePatient
    .trim()
    .toUpperCase()} ${fullLastNamePatient.trim().toUpperCase()}`;

  db.collection("professional")
    .where("dni", "==", values.professionalDNI)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const patientsProfessional = doc.data().patient;
        let patientFind = "";

        if (patientsProfessional !== undefined) {
          patientFind = patientsProfessional.find(
            (patient) =>
              patient.patientDNI.trim().toUpperCase() ===
              data.patientDNI.trim().toUpperCase()
          );
        }

        if (patientFind !== "") {
          db.collection("professional")
            .doc(doc.data().uid)
            .update({
              patient: firebase.firestore.FieldValue.arrayUnion({
                patientDNI: data.patientDNI,
                patientName: `${fullNamePatient.trim()} ${fullLastNamePatient.trim()}`,
              }),
            });
        } else {
          if (fullNameLastNameActual !== fullNameLastNameOld) {
            db.collection("professional")
              .doc(doc.data().uid)
              .update({
                patient: firebase.firestore.FieldValue.arrayRemove(patientFind),
              })
              .then((res) => {
                db.collection("professional")
                  .doc(doc.data().uid)
                  .update({
                    patient: firebase.firestore.FieldValue.arrayUnion({
                      patientDNI: values.patientDNI.trim().toUpperCase(),
                      patientName: fullNameLastNameActual,
                    }),
                  });
              });
          }
        }
      });
    });

  dispatch(setShowAlertMedicineTrue(false));

  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////
  db.collection("attention")
    .doc(values.scheduleCountry.toLowerCase())
    .collection(values.patientDNI)
    .doc(values.timestamp.toString())
    .update({
      // typeConsult: values.typeConsult,
      // typeConsultCode: values.typeConsultCode,
      patientInfo: data,
      attention: dataAttention,
      // professionalNameComplete: values.professionalNameComplete,
      // professionalDNI: values.professionalDNI,
      pathFiles: values.pathFiles,
      timeConsult: values.timeConsult,
      // startTime: new Date(values.timestamp),
      // idDocument: values.idDocument,
      // timestamp: values.timestamp,
    })
    .then((docRef) => {
      db.collection("schedule_ecuador").doc(values.idDocument).update({
        timeEnd: new Date(),
      }).then(() => {

      }).catch((errorTime) => {
        db.collection("errorTimeEnd")
          .add({
            log_date: new Date(),
            error: errorTime.toString(),
            professionalDNI: values.professionalDNI,
            patientDNI: values.patientDNI,
            idDocument: values.idDocument,
          })
      });
    })
    .catch((error) => {
      errorAlert(
        "No se pudo agregar la Ficha con Éxito, notificarlo al Área de TI"
      );
      getIP().then((response) => {
        enviarLogDoctorErrorAddRecord(
          types.doctorAddNewRecord,
          error.toString(),
          values.professionalRut,
          values.professionalName,
          values.patientName,
          values.patientLastName,
          values.idDocument,
          response.data
        );
      });
    });
  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////
};

//Método para agregar la ficha consumiendo consumiendo la data de Schedule y Patient
export const addRecordFromCitasAndUpdateColombia = (
  values,
  valuesPatient,
  professional
) => {
  let data = {
    patientDNITypeCode: values.patientDNITypeCode,
    patientDNITypeName: values.patientDNITypeName,
    patientDNI: values.patientDNI.trim().toUpperCase(),
    patientNameComplete: values.patientNameComplete.trim().toUpperCase(),
    patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
    patientNameFirstLastName: values.patientNameFirstLastName
      .trim()
      .toUpperCase(),
    patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
    patientNameSecondLastName: values.patientNameSecondLastName
      .trim()
      .toUpperCase(),
    patientNameSocial: values.patientNameSocial.trim().toUpperCase(),
    patientPhone: values.patientPhone.trim(),
    patientPhoneCode: values.patientPhoneCode.trim(),
    patientPhoneComplete: values.patientPhoneComplete.trim(),
    patientEmail: values.patientEmail,
    patientAge: values.patientAge,
    patientBirth: values.patientBirth,
    patientBirthCountryId: values.patientBirthCountryId,
    patientBirthCountry: values.patientBirthCountry,
    patientBirthRegionId: values.patientBirthRegionId,
    patientBirthRegion: values.patientBirthRegion,
    patientBirthCityId: values.patientBirthCityId,
    patientBirthCity: values.patientBirthCity,
    patientNationality: values.patientNationality,
    patientResidenceCountryId: values.patientResidenceCountryId,
    patientResidenceCountry: values.patientResidenceCountry,
    patientRegion: values.patientRegion,
    patientCity: values.patientCity,
    patientRegionId: values.patientRegionId,
    patientCityId: values.patientCityId,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientGender: values.patientGender,
    patientEducation: values.patientEducation,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientCivilState: values.patientCivilState,
    patientContactName: values.patientContactName.trim().toUpperCase(),
    patientContactPhone: values.patientContactPhone.trim(),
    patientContactPhoneCode: values.patientContactPhoneCode.trim(),
    patientContactPhoneComplete: values.patientContactPhoneComplete.trim(),
    patientContactEmail: values.patientContactEmail.trim().toUpperCase(),
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientOrientationTypeCode: values.patientOrientationTypeCode,
    patientOrientationTypeName: values.patientOrientationTypeName,
    patientPopulationTypeCode: values.patientPopulationTypeCode,
    patientPopulationTypeName: values.patientPopulationTypeName,
    patientEthnicTypeCode: values.patientEthnicTypeCode,
    patientEthnicTypeName: values.patientEthnicTypeName,
    patientReligion: values.patientReligion.trim().toUpperCase(),
  };

  let dataAntecedent = {
    noPathologicalPatientAlcohol: values.noPathologicalPatientAlcohol.trim(),
    noPathologicalPatientDrugs: values.noPathologicalPatientDrugs.trim(),
    noPathologicalPatientImmunization:
      values.noPathologicalPatientImmunization.trim(),
    noPathologicalPatientOthers: values.noPathologicalPatientOthers.trim(),
    noPathologicalPatientSmoking: values.noPathologicalPatientSmoking.trim(),
    pathologicalPatient: values.pathologicalPatient,
    pathologicalPatientExplanation:
      values.pathologicalPatientExplanation.trim(),
    pathologicalPatientMedicine: values.pathologicalPatientMedicine
      .toUpperCase()
      .trim(),
    recordBroHowMany: values.recordBroHowMany.trim(),
    recordBroLive: values.recordBroLive.trim(),
    recordBroSick: values.recordBroSick.trim(),
    recordDadLive: values.recordDadLive,
    recordDadSick: values.recordDadSick.trim(),
    recordGinecoA: values.recordGinecoA.trim(),
    recordGinecoAnti: values.recordGinecoAnti,
    recordGinecoAntiHow: values.recordGinecoAntiHow.trim(),
    recordGinecoC: values.recordGinecoC.trim(),
    recordGinecoFUM: values.recordGinecoFUM.trim(),
    recordGinecoG: values.recordGinecoG.trim(),
    recordGinecoIVSA: values.recordGinecoIVSA.trim(),
    recordGinecoMenarquia: values.recordGinecoMenarquia.trim(),
    recordGinecoP: values.recordGinecoP.trim(),
    recordGinecoRitmo: values.recordGinecoRitmo.trim(),
    recordMomLive: values.recordMomLive,
    recordMomSick: values.recordMomSick.trim(),
  };

  let dataAttention = {
    // medicalProcedures: values.medicalProcedures,
    // neurologic: values.neurologic,
    // physicalAbdomen: values.physicalAbdomen,
    // physicalChest: values.physicalChest,
    // physicalExtremity: values.physicalExtremity,
    // physicalFC: values.physicalFC,
    // physicalFrecuenceBreath: values.physicalFrecuenceBreath,
    // physicalHeadNeck: values.physicalHeadNeck,
    // physicalSignalTADerecho: values.physicalSignalTADerecho,
    // physicalSignalTAIzquierdo: values.physicalSignalTAIzquierdo,
    // physicalTemp: values.physicalTemp,
    // treatment: values.treatment,
    antecedent: dataAntecedent,
    diagnosis: values.diagnosis,
    diagnosisRelated: values.diagnosisRelated,
    illnes: values.illnes,
    medicalOrders: values.medicalOrders,
    medicines: values.medicinesPatient,
    mental: values.mental,
    physicalHeight: values.physicalHeight,
    physicalIMC: values.physicalIMC,
    physicalWeight: values.physicalWeight,
    reasonConsultation: values.reasonConsultation,
    relevantDetails: values.relevantDetails,
    planAndAnalysis: values.planAndAnalysis,
  };

  return async (dispatch) => {
    saveDataRecordColombia(
      values,
      data,
      dataAttention,
      valuesPatient,
      professional,
      dispatch,
      true
    );
  };
};

//Método para agregar la ficha psicología (primera atencion) consumiendo la data de Schedule y Patient
export const addRecPsyFromCitasAndUpdateColombia = (
  values,
  valuesPatient,
  younger,
  professional
) => {
  let data = {
    patientDNITypeCode: values.patientDNITypeCode,
    patientDNITypeName: values.patientDNITypeName,
    patientDNI: values.patientDNI.trim().toUpperCase(),
    patientNameComplete: values.patientNameComplete.trim().toUpperCase(),
    patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
    patientNameFirstLastName: values.patientNameFirstLastName
      .trim()
      .toUpperCase(),
    patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
    patientNameSecondLastName: values.patientNameSecondLastName
      .trim()
      .toUpperCase(),
    patientNameSocial: values.patientNameSocial.trim().toUpperCase(),
    patientPhone: values.patientPhone.trim(),
    patientPhoneCode: values.patientPhoneCode.trim(),
    patientPhoneComplete: values.patientPhoneComplete.trim(),
    patientEmail: values.patientEmail,
    patientAge: values.patientAge,
    patientBirth: values.patientBirth,
    patientBirthCountryId: values.patientBirthCountryId,
    patientBirthCountry: values.patientBirthCountry,
    patientBirthRegionId: values.patientBirthRegionId,
    patientBirthRegion: values.patientBirthRegion,
    patientBirthCityId: values.patientBirthCityId,
    patientBirthCity: values.patientBirthCity,
    patientNationality: values.patientNationality,
    patientResidenceCountryId: values.patientResidenceCountryId,
    patientResidenceCountry: values.patientResidenceCountry,
    patientRegion: values.patientRegion,
    patientCity: values.patientCity,
    patientRegionId: values.patientRegionId,
    patientCityId: values.patientCityId,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientGender: values.patientGender,
    patientEducation: values.patientEducation,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientCivilState: values.patientCivilState,
    patientContactName: values.patientContactName.trim().toUpperCase(),
    patientContactPhone: values.patientContactPhone.trim(),
    patientContactPhoneCode: values.patientContactPhoneCode.trim(),
    patientContactPhoneComplete: values.patientContactPhoneComplete.trim(),
    patientContactEmail: values.patientContactEmail.trim().toUpperCase(),
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientOrientationTypeCode: values.patientOrientationTypeCode,
    patientOrientationTypeName: values.patientOrientationTypeName,
    patientPopulationTypeCode: values.patientPopulationTypeCode,
    patientPopulationTypeName: values.patientPopulationTypeName,
    patientEthnicTypeCode: values.patientEthnicTypeCode,
    patientEthnicTypeName: values.patientEthnicTypeName,
    patientReligion: values.patientReligion.trim().toUpperCase(),
  };

  let dataAttention = {
    reasonConsultation: values.reasonConsultation.trim(),
    illnes: values.illnes.trim(),
    past: values.past.trim(),
    mental: values.mental.trim(),
    areaAcademic: values.areaAcademic.trim(),
    areaPersonal: values.areaPersonal.trim(),
    areaWork: values.areaWork.trim(),
    areaFamily: values.areaFamily.trim(),
    areaSocial: values.areaSocial.trim(),
    areaCouple: values.areaCouple.trim(),
    areaSexual: values.areaSexual.trim(),
    areaConsumeSPA: values.areaConsumeSPA.trim(),
    areaEconomic: values.areaEconomic.trim(),
    areaRulesLimits: values.areaRulesLimits.trim(),
    areaSuicidalIdeation: values.areaSuicidalIdeation.trim(),
    areaReligious: values.areaReligious.trim(),
    processExpectations: values.processExpectations.trim(),
    followUpPlan: values.followUpPlan.trim(),
    riskLevel: values.riskLevel,
    psychoEducation: values.psychoEducation.trim(),
    referralSecondLevel: values.referralSecondLevel.trim(),
    attentionRoutes: values.attentionRoutes.trim(),
    conclusions: values.conclusions.trim(),
  };

  if (values?.diagnosis || values?.diagnosis === "") {
    dataAttention.diagnosis = values.diagnosis;
  }

  if (values?.diagnosisRelated) {
    dataAttention.diagnosisRelated = values.diagnosisRelated;
  }

  if (younger) {
    dataAttention.areaAffective = values.areaAffective.trim();
    dataAttention.attentionBirth = values.attentionBirth.trim();
    dataAttention.attentionGestation = values.attentionGestation.trim();
    dataAttention.attentionNewborn = values.attentionNewborn.trim();
    dataAttention.attentionRecreation = values.attentionRecreation.trim();
    dataAttention.behaviorHoldingHead = values.behaviorHoldingHead.trim();
    dataAttention.behaviorBabble = values.behaviorBabble.trim();
    dataAttention.behaviorSitAlone = values.behaviorSitAlone.trim();
    dataAttention.behaviorCrawl = values.behaviorCrawl.trim();
    dataAttention.behaviorWalkAlone = values.behaviorWalkAlone.trim();
    dataAttention.behaviorFirstWord = values.behaviorFirstWord.trim();
    dataAttention.behaviorSeveralWords = values.behaviorSeveralWords.trim();
    dataAttention.behaviorToiletTraining = values.behaviorToiletTraining.trim();
    dataAttention.behaviorFeedAlone = values.behaviorFeedAlone.trim();
    dataAttention.behaviorDressingAlone = values.behaviorDressingAlone.trim();
    dataAttention.behaviorBatheAlone = values.behaviorBatheAlone.trim();
    dataAttention.behaviorSleepAlone = values.behaviorSleepAlone.trim();
  }

  return async (dispatch) => {
    saveDataRecordColombia(
      values,
      data,
      dataAttention,
      valuesPatient,
      professional,
      dispatch,
      true
    );
  };
};

//Método para agregar la ficha psicología (control) consumiendo la data de Schedule y Patient
export const addRecPsyControlFromCitasAndUpdateColombia = (
  values,
  valuesPatient,
  professional
) => {

  let data = {
    patientDNITypeCode: values.patientDNITypeCode,
    patientDNITypeName: values.patientDNITypeName,
    patientDNI: values.patientDNI.trim().toUpperCase(),
    patientNameComplete: values.patientNameComplete.trim().toUpperCase(),
    patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
    patientNameFirstLastName: values.patientNameFirstLastName
      .trim()
      .toUpperCase(),
    patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
    patientNameSecondLastName: values.patientNameSecondLastName
      .trim()
      .toUpperCase(),
    patientNameSocial: values.patientNameSocial.trim().toUpperCase(),
    patientPhone: values.patientPhone.trim(),
    patientPhoneCode: values.patientPhoneCode.trim(),
    patientPhoneComplete: values.patientPhoneComplete.trim(),
    patientEmail: values.patientEmail,
    patientAge: values.patientAge,
    patientBirth: values.patientBirth,
    patientBirthCountryId: values.patientBirthCountryId,
    patientBirthCountry: values.patientBirthCountry,
    patientBirthRegionId: values.patientBirthRegionId,
    patientBirthRegion: values.patientBirthRegion,
    patientBirthCityId: values.patientBirthCityId,
    patientBirthCity: values.patientBirthCity,
    patientNationality: values.patientNationality,
    patientResidenceCountryId: values.patientResidenceCountryId,
    patientResidenceCountry: values.patientResidenceCountry,
    patientRegion: values.patientRegion,
    patientCity: values.patientCity,
    patientRegionId: values.patientRegionId,
    patientCityId: values.patientCityId,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientGender: values.patientGender,
    patientEducation: values.patientEducation,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientCivilState: values.patientCivilState,
    patientContactName: values.patientContactName.trim().toUpperCase(),
    patientContactPhone: values.patientContactPhone.trim(),
    patientContactPhoneCode: values.patientContactPhoneCode.trim(),
    patientContactPhoneComplete: values.patientContactPhoneComplete.trim(),
    patientContactEmail: values.patientContactEmail.trim().toUpperCase(),
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientOrientationTypeCode: values.patientOrientationTypeCode,
    patientOrientationTypeName: values.patientOrientationTypeName,
    patientPopulationTypeCode: values.patientPopulationTypeCode,
    patientPopulationTypeName: values.patientPopulationTypeName,
    patientEthnicTypeCode: values.patientEthnicTypeCode,
    patientEthnicTypeName: values.patientEthnicTypeName,
    patientReligion: values.patientReligion.trim().toUpperCase(),
  };

  let dataAttention = {
    activities: values.activities,
    anamnesis: values.anamnesis,
    familyInvolment: values.familyInvolment,
    followUpPlan: values.followUpPlan,
    objectiveSession: values.objectiveSession,
    observations: values.observations,
    progress: values.progress,
    conclusions: values.conclusions,
  };

  return async (dispatch) => {
    saveDataRecordColombia(
      values,
      data,
      dataAttention,
      valuesPatient,
      professional,
      dispatch,
      true
    );
  };
};

//Método para guardar la ficha médica Colombia
export const saveDataRecordColombia = (
  values,
  data,
  dataAttention,
  valuesPatient,
  professional,
  dispatch,
  control
) => {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;
  const urlServer = reduxState.companyInstance.urlServer;
  /////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBE ACTUALIZAR ALGÚN CAMPO DEL PACIENTE EN PATIENT ////////////////////////////////////////////
  const patientInfoOld = valuesPatient.patient;

  const fullNameLastNameOld = `${patientInfoOld.patientNameFirst
    .trim()
    .toUpperCase()} ${patientInfoOld.patientNameSecond
      .trim()
      .toUpperCase()} ${patientInfoOld.patientNameFirstLastName
        .trim()
        .toUpperCase()} ${patientInfoOld.patientNameSecondLastName
          .trim()
          .toUpperCase()}`
    .replaceAll("  ", " ")
    .trim();
  const patientFullNameActual = values.patientNameComplete;

  const patientInfoActual = {
    patientDNITypeCode: values.patientDNITypeCode,
    patientDNITypeName: values.patientDNITypeName,
    patientDNI: values.patientDNI.trim().toUpperCase(),
    patientNameComplete: values.patientNameComplete.trim().toUpperCase(),
    patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
    patientNameFirstLastName: values.patientNameFirstLastName
      .trim()
      .toUpperCase(),
    patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
    patientNameSecondLastName: values.patientNameSecondLastName
      .trim()
      .toUpperCase(),
    patientNameSocial: values.patientNameSocial.trim().toUpperCase(),
    patientPhone: values.patientPhone.trim(),
    patientPhoneCode: values.patientPhoneCode.trim(),
    patientPhoneComplete: values.patientPhoneComplete.trim(),
    patientEmail: values.patientEmail,
    patientAge: values.patientAge,
    patientBirth: values.patientBirth,
    patientBirthCountryId: values.patientBirthCountryId,
    patientBirthCountry: values.patientBirthCountry,
    patientBirthRegionId: values.patientBirthRegionId,
    patientBirthRegion: values.patientBirthRegion,
    patientBirthCityId: values.patientBirthCityId,
    patientBirthCity: values.patientBirthCity,
    patientNationality: values.patientNationality,
    patientResidenceCountryId: values.patientResidenceCountryId,
    patientResidenceCountry: values.patientResidenceCountry,
    patientRegion: values.patientRegion,
    patientCity: values.patientCity,
    patientRegionId: values.patientRegionId,
    patientCityId: values.patientCityId,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientGender: values.patientGender,
    patientEducation: values.patientEducation,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientCivilState: values.patientCivilState,
    patientContactName: values.patientContactName.trim().toUpperCase(),
    patientContactPhone: values.patientContactPhone.trim(),
    patientContactEmail: values.patientContactEmail.trim().toUpperCase(),
    patientPlanMedicalCode: values.patientPlanMedicalCode,
    patientPlanMedicalName: values.patientPlanMedicalName,
    patientOrientationTypeCode: values.patientOrientationTypeCode,
    patientOrientationTypeName: values.patientOrientationTypeName,
    patientPopulationTypeCode: values.patientPopulationTypeCode,
    patientPopulationTypeName: values.patientPopulationTypeName,
    patientEthnicTypeCode: values.patientEthnicTypeCode,
    patientEthnicTypeName: values.patientEthnicTypeName,
    patientReligion: values.patientReligion.trim().toUpperCase(),
  };

  professional.nameComplete = values.professionalNameComplete;

  if (
    values.patientNameFirst.trim().toUpperCase() !==
    patientInfoOld.patientNameFirst.trim().toUpperCase() ||
    values.patientNameFirstLastName.trim().toUpperCase() !==
    patientInfoOld.patientNameSecond.trim().toUpperCase() ||
    values.patientNameSecond.trim().toUpperCase() !==
    patientInfoOld.patientNameFirstLastName.trim().toUpperCase() ||
    values.patientNameSecondLastName.trim().toUpperCase() !==
    patientInfoOld.patientNameSecondLastName.trim().toUpperCase() ||
    values.patientNameSocial.trim().toUpperCase() !==
    patientInfoOld.patientNameSocial ||
    values.patientPhone.trim() !== patientInfoOld.patientPhone ||
    values.patientPhoneCode.trim() !== patientInfoOld.patientPhoneCode ||
    values.patientPhoneComplete.trim() !==
    patientInfoOld.patientPhoneComplete ||
    values.patientEmail !== patientInfoOld.patientEmail ||
    values.patientAge !== patientInfoOld.patientAge ||
    values.patientBirth !== patientInfoOld.patientBirth ||
    values.patientBirthCountry !== patientInfoOld.patientBirthCountry ||
    values.patientBirthRegionId !== patientInfoOld.patientBirthRegionId ||
    values.patientBirthRegion !== patientInfoOld.patientBirthRegion ||
    values.patientBirthCityId !== patientInfoOld.patientBirthCityId ||
    values.patientBirthCity !== patientInfoOld.patientBirthCity ||
    values.patientNationality !== patientInfoOld.patientNationality ||
    values.patientResidenceCountry !== patientInfoOld.patientResidenceCountry ||
    values.patientRegion !== patientInfoOld.patientRegion ||
    values.patientCity !== patientInfoOld.patientCity ||
    values.patientRegionId !== patientInfoOld.patientRegionId ||
    values.patientCityId !== patientInfoOld.patientCityId ||
    values.patientAddress.trim().toUpperCase() !==
    patientInfoOld.patientAddress ||
    values.patientGender !== patientInfoOld.patientGender ||
    values.patientEducation !== patientInfoOld.patientEducation ||
    values.patientOccupation.trim().toUpperCase() !==
    patientInfoOld.patientOccupation ||
    values.patientCivilState !== patientInfoOld.patientCivilState ||
    values.patientContactName.trim().toUpperCase() !==
    patientInfoOld.patientContactName ||
    values.patientContactPhone.trim() !== patientInfoOld.patientContactPhone ||
    values.patientContactEmail.trim().toUpperCase() !==
    patientInfoOld.patientContactEmail ||
    values.patientPlanMedicalCode !== patientInfoOld.patientPlanMedicalCode ||
    values.patientPlanMedicalName !== patientInfoOld.patientPlanMedicalName ||
    values.patientOrientationTypeCode !==
    patientInfoOld.patientOrientationTypeCode ||
    values.patientOrientationTypeName !==
    patientInfoOld.patientOrientationTypeName ||
    values.patientPopulationTypeCode !==
    patientInfoOld.patientPopulationTypeCode ||
    values.patientPopulationTypeName !==
    patientInfoOld.patientPopulationTypeName ||
    values.patientEthnicTypeCode !== patientInfoOld.patientEthnicTypeCode ||
    values.patientEthnicTypeName !== patientInfoOld.patientEthnicTypeName ||
    values.patientReligion.trim().toUpperCase() !==
    patientInfoOld.patientReligion
  ) {
    db.collection("patient_colombia")
      .doc(values.patientDNI)
      .update({ ...patientInfoActual })
      .then(() => {
        getIP().then((responseIP) => {
          logUpdateDataPatient(
            patientFullNameActual,
            patientInfoOld,
            patientInfoActual,
            professional,
            responseIP.data
          );
        });
      })
      .catch((error) => { });
  }

  /////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBE ACTUALIZAR ALGÚN CAMPO DEL PACIENTE EN PATIENT ////////////////////////////////////////////
  db.collection("professional")
    .where("dni", "==", values.professionalDNI)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const patientsProfessional = doc.data().patient;
        let patientFind = "";

        if (patientsProfessional !== undefined) {
          patientFind = patientsProfessional.find(
            (patient) =>
              patient.patientDNI.trim().toUpperCase() ===
              data.patientDNI.trim().toUpperCase()
          );
        }

        if (patientFind !== "") {
          db.collection("professional")
            .doc(doc.data().uid)
            .update({
              patient: firebase.firestore.FieldValue.arrayUnion({
                patientDNI: data.patientDNI,
                patientName: data.patientNameComplete,
              }),
            });
        } else {
          if (patientFullNameActual !== fullNameLastNameOld) {
            db.collection("professional")
              .doc(doc.data().uid)
              .update({
                patient: firebase.firestore.FieldValue.arrayRemove(patientFind),
              })
              .then((res) => {
                db.collection("professional")
                  .doc(doc.data().uid)
                  .update({
                    patient: firebase.firestore.FieldValue.arrayUnion({
                      patientDNI: values.patientDNI.trim().toUpperCase(),
                      patientName: patientFullNameActual,
                    }),
                  });
              });
          }
        }
      });
    });
  /////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBE ACTUALIZAR ALGÚN CAMPO DEL PACIENTE EN PATIENT ////////////////////////////////////////////

  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////
  db.collection("attention")
    .doc("colombia")
    .collection(values.patientDNI)
    .doc(values.timestamp.toString())
    .update({
      typeConsult: values.typeConsult,
      typeConsultCode: values.typeConsultCode,
      patientInfo: data,
      attention: dataAttention,
      // professionalName: values.professionalNameComplete,
      // professionalDNI: values.professionalDNI,
      pathFiles: values.pathFiles,
      timeConsult: values.timeConsult,
      notify: values.notify
      // startTime: new Date(values.timestamp),
      // idDocument: values.idDocument,
      // timestamp: values.timestamp,
      // control
    })
    .then((docRef) => {
      const { dateSchedule, hourStartSchedule, hourEndSchedule } =
        returnDates(values);

      const dataResume = {
        idDocument: values.idDocument,
        email: values.patientEmail,
        patientDNI: values.patientDNI,
        patientName: `${values.patientNameComplete} ${values.patientLastNameComplete}`,
        professionalDNI: values.professionalDNI,
        professionalName: values.professionalNameComplete,
        specialtyName: values.typeConsult,
        date: dateSchedule,
        timeStart: hourStartSchedule,
        timeEnd: hourEndSchedule,
        resume: dataAttention.medicalOrders ?? dataAttention.conclusions,
        timeZone: values.timeZone,
        files: values.files,
        scheduleDiscount: values.scheduleDiscount,
        scheduleDiscountCode: values.scheduleDiscountCode,
        timestamp: values.timestamp
      };

      if (dataAttention?.diagnosis || dataAttention?.diagnosis === "")
        dataResume.diagnosis = dataAttention.diagnosis.label ?? "";

      if (dataAttention?.diagnosisRelated?.length > 0) {
        dataResume.diagnosisRelated = [];
        dataAttention.diagnosisRelated.forEach((diagnos) => {
          dataResume.diagnosisRelated.push(diagnos.label);
        });
      }

      // axios.post(`${urlServer}/yeminus/yeminusEnqueueCreateBillTask`, {
      //   patient: patientInfoActual,
      //   professional,
      //   attention: {
      //     ...dataAttention.diagnosis,
      //     serviceCode: values.serviceCode,
      //     schedulePriceTotal: valuesPatient.schedule.schedulePriceTotal,
      //     idDocument: values.idDocument,
      //     timestamp: values.timestamp
      //   }
      // });

      axios
        .post(`${urlServer}/mails/resumeAtencion`, dataResume)
        .then((response) => {
          getIP().then((res) => {
            enviarLogNotifyResume2(
              "[Resume] Send Medical Resume",
              response.data.message,
              values.professionalDNI,
              values.professionalNameComplete,
              values.patientDNI,
              values.patientNameComplete,
              res.data
            );
          });
        })
        .catch((error) => {
          errorAlert(
            "No se pudo enviar el Resumen de la Atención, notificarlo al Área de TI"
          );
          getIP().then((response) => {
            enviarLogErrorNotifyResume2(
              "[Resume] Send Medical Resume",
              error.toString(),
              values.professionalDNI,
              values.professionalNameComplete,
              values.patientDNI,
              values.patientNameComplete,
              response.data
            );
          });
        });

      db.collection("schedule_colombia").doc(values.idDocument).update({
        timeEnd: new Date(),
        notify: values.notify
      });
    })
    .catch((error) => {
      console.log(error);
      errorAlert(
        "No se pudo agregar la Ficha con Éxito, notificarlo al Área de TI"
      );
      getIP().then((response) => {
        enviarLogDoctorErrorAddRecord(
          types.doctorAddNewRecord,
          error.toString(),
          values.professionalDNI,
          values.professionalNameComplete,
          values.patientDNI,
          values.patientNameComplete,
          values.idDocument,
          response.data
        );
      });
    });
  ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////
};

export const createOrderAndProcedure = (
  dataAttention,
  idDoctorRecemed,
  idPatientRecemed,
  values,
  data,
  valuesPatient,
  dispatch,
  receta
) => {
  if (dataAttention.medicalProcedures !== "") {
    const procedures = `${dataAttention.diagnosis.label}\n\n${dataAttention.medicalProcedures}`;

    createProcedure(
      idDoctorRecemed,
      idPatientRecemed,
      procedures,
      values.professionalDNI,
      values.professionalNameComplete,
      values.patientDNI,
      values.patientName,
      values.patientLastName,
      dispatch
    ).then((responseProcedure) => {
      if (responseProcedure.status === 200) {
        ///////////////////////////////////////////// INICIO ÓRDEN MÉDICA RECEMED /////////////////////////////////////////////
        if (dataAttention.medicalOrders.length > 0) {
          let order = `${dataAttention.diagnosis.label}\n\n`;
          dataAttention.medicalOrders.forEach((ord) => {
            order += `\n${ord.examen}`;
          });

          createOrder(
            idDoctorRecemed,
            idPatientRecemed,
            order,
            dataAttention.medicalOrderDetail,
            values.professionalDNI,
            values.professionalNameComplete,
            values.patientDNI,
            values.patientName,
            values.patientLastName,
            dispatch
          ).then((responseOrder) => {
            const dataToResume = { ...values };
            dataToResume.respOrder = { ...responseOrder };
            dataToResume.respReceta = { ...receta ?? null };
            // batchExams(responseOrder, values);
            resumeAttentionCL(dataToResume);
          });
        }
        ///////////////////////////////////////////// FIN ÓRDEN MÉDICA RECEMED /////////////////////////////////////////////
      }
    });
  } else {
    if (dataAttention.medicalOrders.length > 0) {
      let order = `${dataAttention.diagnosis.label}\n\n`;
      dataAttention.medicalOrders.forEach((ord) => {
        order += `\n${ord.examen}`;
      });

      createOrder(
        idDoctorRecemed,
        idPatientRecemed,
        order,
        dataAttention.medicalOrderDetail,
        values.professionalDNI,
        values.professionalNameComplete,
        values.patientDNI,
        values.patientName,
        values.patientLastName,
        dispatch
      ).then((responseOrder) => {
        const dataToResume = { ...values };
        dataToResume.respOrder = { ...responseOrder };
        dataToResume.respReceta = { ...receta ?? null };

        resumeAttentionCL(dataToResume);
      });
    } else {
      // dispatch(setShowAlertOrderTrue(false));
      dispatch(setShowAlertMedicineTrue(false));
    }
  }
};

// function batchExams(responseOrder, values) {
//   const { response } = responseOrder;
//   const dataRes = { ...response.data };

//   const refSchedule = db.collection("schedule_chile").doc(values.idDocument);
//   const refRecord = db.collection("attention")
//     .doc(values.scheduleCountry.replaceAll(" ", "").toLowerCase())
//     .collection(values.patientDNI)
//     .doc(values.timestamp.toString());

//   const batch = firebase.firestore().batch();

//   batch.update(refSchedule, { exams: { id: dataRes.id, url: dataRes.url } });
//   batch.update(refRecord, { exams: { id: dataRes.id, url: dataRes.url } });

//   const dataToExamed = {
//     RUT_PAC: values.patientDNI,
//     DNI_PAC: "",
//     NOM_PAC: values.patientName,
//     APE_PAC: values.patientLastName,
//     Sexo: values.patientGender,
//     ID_NAC: values.patientNationality,
//     Fecha_Nac: values.patientBirth,
//     Direccion: values.patientAddress,
//     Telefono: values.patientPhone,
//     Correo: values.patientEmail,
//     ID_COM: values.patientCity,
//     OBS: values.medicalOrderDetail,
//     ID_HOST_PROFESIONAL: values.host,
//     RUT_Profesional: values.professionalDNI,
//     Nombre_Profesional: values.professionalName,
//     Apellido_Profesional: values.professionalLastName,
//     Examenes: values.medicalOrders,
//     idDocument: values.idDocument,
//     timestamp: values.timestamp
//   };

//   batch.commit()
//     .then(() => {
//       axios.post(`${urlServer}/examed/examsEnqueueTask`, dataToExamed);
//     })
// }

//Método para obtener el ID del paciente en RECEMED
const getIDDoctor = async (
  professionalRut,
  patientRut,
  timestamp,
  timeZone
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  try {
    const response = await axios.get(
      `${urlServer}/recemed/medicoid/${professionalRut}`
    );

    if (response.data.status === "200") {
      return response.data.id;
    }
  } catch (error) {
    getIP().then((response) => {
      enviarLogErrorIntegrations(
        "[Recemed] Get ID Professional",
        error.toString(),
        professionalRut,
        response.data,
        patientRut,
        timestamp,
        timeZone
      );
    });
  }
};

//Método para obtener el ID del paciente en RECEMED
const getIDPaciente = async (data, professionalRut, timestamp, timeZone) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;
  try {
    const response = await axios.get(
      `${urlServer}/recemed/pacienteid/${data.patientDNI}`
    );

    if (response.data.status === "200") {
      return response.data.id;
    } else {
      return createPaciente(data, professionalRut, timestamp, timeZone);
    }
  } catch (error) {
    errorAlert(
      "Este paciente no pudo crearse en Recemed, notificarlo al Área de TI"
    );
    getIP().then((response) => {
      enviarLogErrorIntegrations(
        "[Recemed] Get ID Patient",
        error.toString(),
        professionalRut,
        response.data,
        data.patientDNI,
        timestamp,
        timeZone
      );
    });
  }
};

// Método para crear el paciente en RECEMED
const createPaciente = async (dataFicha, professionalRut, timestamp, timeZone) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  const dateBirth = (dataFicha.patientBirthDate ?? dataFicha.patientBirth).split("-").reverse().join("-");
  const patientName = `${dataFicha.patientNameFirst} ${dataFicha.patientNameSecond}`;
  const patientLastName = `${dataFicha.patientNameFirstLastName} ${dataFicha.patientNameSecondLastName}`;

  const data = {
    rut: dataFicha.patientDNI,
    nombres: patientName,
    apellidos: patientLastName,
    email: dataFicha.patientEmail,
    direccion: dataFicha.patientAddress,
    sexo: dataFicha.patientGender,
    fecha_nac: dateBirth,
    comuna: dataFicha.patientRegion,
    ciudad: dataFicha.patientCity,
    telefono: dataFicha.patientPhone,
  };

  try {
    const response = await axios.post(`${urlServer}/recemed/addpaciente`, data);
    return response.data.id;
  } catch (error) {
    getIP().then((response) => {
      enviarLogErrorIntegrations(
        "[Recemed] Add Patient",
        error.toString(),
        professionalRut,
        response.data,
        data.patientDNI,
        timestamp,
        timeZone
      );
    });
    return error.toString();
  }
};

const createNoWithHeldMedicines = (
  idDoctor,
  idPacient,
  observationsNoWithheldMedicines,
  patientMedicalPlan,
  profName,
  profRut,
  patientName,
  patientLastName,
  patientRut,
  dispatch
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  return new Promise((resolve, reject) => {
    const data = {
      medico: idDoctor,
      paciente: idPacient,
      atributos: {
        detalle: observationsNoWithheldMedicines,
        observaciones: observationsNoWithheldMedicines,
        registra_ges: null,
        patologia: null,
        isapre: patientMedicalPlan,
        duracion: 0,
      },
    };

    axios
      .post(`${urlServer}/recemed/addrecetadigital`, data)
      .then((response) => {
        // if (response.data.statusCode === 500) {
        if (response.data.error) {
          dispatch(setShowAlertMedicineTrue(false));
          errorAlert(response.data.error.mensaje);
          // errorAlert('No se pudo crear la Receta NO Retenida, notificarlo al Área de TI');
          getIP().then((responseIP) => {
            enviarLogErrorCreatePrescription(
              "[Recemed] Create Prescription NoWithheld",
              { ...response.data.error.error },
              profRut,
              profName,
              patientRut,
              patientName,
              patientLastName,
              responseIP.data
            );
          });
          reject({ status: 500, msg: "No se pudieron crear las Medicinas" });
        } else {
          logRecemed(
            "[Create Receta]",
            "No Retenida",
            response,
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            observationsNoWithheldMedicines
          );
          resolve({ status: 200, msg: "Medicinas creadas con Éxito" });
        }
      })
      .catch((error) => {
        dispatch(setShowAlertMedicineTrue(false));
        errorAlert(
          "No se pudo crear la Receta NO Retenida, notificarlo al Área de TI"
        );
        getIP().then((response) => {
          enviarLogErrorCreatePrescription(
            "[Recemed] Create Prescription NoWithheld",
            error.toString(),
            profRut,
            profName,
            patientRut,
            patientName,
            patientLastName,
            response.data
          );
        });
      });
  });
};

// Método para crear recetas en RECEMED
const createReceta = (
  patientMedicalPlan,
  idDoctor,
  idPacient,
  medicines,
  ges,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  return new Promise((resolve, reject) => {
    console.log(medicines);

    const withheldMedicines = [];

    let detailNoWithheldMedicines = "";
    let observationsNoWithheldMedicines = "";

    let continueCreate = true;

    medicines.forEach((medicine, index) => {
      if (medicine.control) {
        withheldMedicines.push(medicine);
      } else {
        detailNoWithheldMedicines += `${medicine.name.data.name}\n`;
        observationsNoWithheldMedicines += `${medicine.name.data.name}
      ${medicine.resume_indication.morning === ""
            ? ""
            : `\n\t ${medicine.resume_indication.morning}`
          }${medicine.resume_indication.afternoon === ""
            ? ""
            : `\n\t ${medicine.resume_indication.afternoon}`
          }${medicine.resume_indication.night === ""
            ? ""
            : ` \n\t ${medicine.resume_indication.night}`
          }${medicine.resume_indication.days === ""
            ? ""
            : `\n\t ${medicine.resume_indication.days}`
          }${medicine.resume_indication.number_boxes === ""
            ? ""
            : `\n\t ${medicine.resume_indication.box}`
          }${medicine.indication === ""
            ? ""
            : `\n\n\t Indicaciones Adicionales \n\t\t -${medicine.indication}
          `
          }
      \n`;
      }
    });

    // if (continueCreate) {
    if (withheldMedicines.length > 0) {
      let contador = 0;

      for (let medicine of withheldMedicines) {
        contador += 1;

        const indication = `${medicine.resume_indication.morning === ""
          ? ""
          : `\n\t ${medicine.resume_indication.morning}`
          }${medicine.resume_indication.afternoon === ""
            ? ""
            : `\n\t ${medicine.resume_indication.afternoon}`
          }${medicine.resume_indication.night === ""
            ? ""
            : ` \n\t ${medicine.resume_indication.night}`
          }${medicine.resume_indication.days === ""
            ? ""
            : `\n\t ${medicine.resume_indication.days}`
          }${medicine.resume_indication.number_boxes === ""
            ? ""
            : `\n\t ${medicine.resume_indication.box}`
          }${medicine.indication === ""
            ? ""
            : `\n\nIndicaciones Adicionales\n\t -${medicine.indication}`
          }`;

        const data = {
          medico: idDoctor,
          paciente: idPacient,
          atributos: {
            detalle: medicine.name.data.name,
            observaciones: indication,
            retenida: true,
            registra_ges: null,
            patologia: null,
            isapre: patientMedicalPlan,
            duracion: Math.round(medicine.days / 30),
          },
        };

        axios
          .post(`${urlServer}/recemed/addreceta`, data)
          // eslint-disable-next-line no-loop-func
          .then((response) => {
            // if (response.data.statusCode === 500) {
            if (response.data.error) {
              dispatch(setShowAlertMedicineTrue(false));
              errorAlert(response.data.error.mensaje);
              // errorAlert('No se pudo crear la Receta Retenida, notificarlo al Área de TI');
              getIP().then((responseIP) => {
                enviarLogErrorCreatePrescription(
                  "[Recemed] Create Prescription NoWithheld",
                  { ...response.data.error.error },
                  profRut,
                  profName,
                  patientRut,
                  patientName,
                  patientLastName,
                  responseIP.data
                );
              });
            } else {
              logRecemed(
                "[Create Receta]",
                "Retenida",
                response,
                profName,
                profRut,
                patientName,
                patientLastName,
                patientRut,
                medicine
              );
              if (contador === withheldMedicines.length) {
                if (detailNoWithheldMedicines !== "" && continueCreate) {
                  continueCreate = false;
                  resolve(
                    createNoWithHeldMedicines(
                      idDoctor,
                      idPacient,
                      observationsNoWithheldMedicines,
                      patientMedicalPlan,
                      profName,
                      profRut,
                      patientName,
                      patientLastName,
                      patientRut,
                      dispatch
                    )
                  );
                } else {
                  resolve({ status: 200, msg: "Medicinas creadas con Éxito" });
                }
              }
            }
          })
          .catch((error) => {
            dispatch(setShowAlertMedicineTrue(false));
            getIP().then((response) => {
              errorAlert(
                "No se pudo crear la Receta Retenida, notificarlo al Área de TI"
              );
              enviarLogErrorCreatePrescription(
                "[Recemed] Create Prescription Withheld",
                error.toString(),
                profRut,
                profName,
                patientRut,
                patientName,
                patientLastName,
                response.data
              );
            });
          });
      }
    } else {
      if (detailNoWithheldMedicines !== "") {
        resolve(
          createNoWithHeldMedicines(
            idDoctor,
            idPacient,
            observationsNoWithheldMedicines,
            patientMedicalPlan,
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            dispatch
          )
        );
      }
    }
    // }
  });
};

// Método para crear recetas en RECEMED desde la Ficha Guardada
const createRecetaFromRecord = (
  patientPlanMedicalName,
  idDoctor,
  idPacient,
  medicine,
  ges,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch,
  dataAppointment
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  const indication = `${medicine.resume_indication.morning === ""
    ? ""
    : `\n\t ${medicine.resume_indication.morning}`
    }${medicine.resume_indication.afternoon === ""
      ? ""
      : `\n\t ${medicine.resume_indication.afternoon}`
    }${medicine.resume_indication.night === ""
      ? ""
      : ` \n\t ${medicine.resume_indication.night}`
    }${medicine.resume_indication.days === ""
      ? ""
      : `\n\t ${medicine.resume_indication.days}`
    }${medicine.resume_indication.number_boxes === ""
      ? ""
      : `\n\t ${medicine.resume_indication.box}`
    }${medicine.indication === ""
      ? ""
      : `\n\nIndicaciones Adicionales\n\t -${medicine.indication}`
    }`;

  const data = {
    medico: idDoctor,
    paciente: idPacient,
    atributos: {
      detalle: medicine.name.data.name,
      observaciones: indication,
      registra_ges: null,
      patologia: null,
      isapre: patientPlanMedicalName,
      duracion: Math.round(medicine.days / 30),
    },
  };

  if (medicine.control) data.atributos.retenida = true;
  const endpoint = medicine.control ? "addreceta" : "addrecetadigital";
  const action = medicine.control ? "[Recemed] Create Prescription Withheld" : "[Recemed] Create Prescription NoWithheld";
  const logAction = medicine.control ? "Retenida" : "No Retenida";

  axios
    .post(`${urlServer}/recemed/${endpoint}`, data)
    .then((response) => {
      console.log(`response ${action}`, response)

      if (response.data.error) {
        errorAlert(response.data.error.mensaje);
        dispatch(setShowAlertMedicineTrue(false));
      } else {
        if (dataAppointment.notify) {
          const idDocument = dataAppointment.idDocument;
          const dni = patientRut;
          const timestamp = dataAppointment.timestamp;
          const products = [{ productId: medicine.name.id }]

          const userData = {
            firstName: patientName,
            lastName: patientLastName,
            email: dataAppointment.patientEmail,
            rut: patientRut,
            phoneNumber: dataAppointment.patientPhone,
            streetName: dataAppointment.patientAddress,
            streetNumber: "",
            commune: dataAppointment.patientCity,
            region: dataAppointment.patientRegion,
            details: ""
          };

          axios.post(`${urlServer}/buho/prescriptionEnqueueTask`, {
            idDocument,
            dni,
            timestamp,
            products,
            userData,
            prescription: response.data,
            control: medicine.control,
            prescriptionToArray: {
              prescription: response.data,
              prescriptionName: {
                id: medicine.name.id,
                name: medicine.name.data.name
              }
            },
            professionalDNI: profRut,
            professionalName: profName
          });
        }
        dispatch(setShowAlertMedicineTrue(false));
        successAlert(`Receta ${logAction} creada con Éxito`);
        logRecemed(
          "[Create Receta]",
          logAction,
          response,
          profName,
          profRut,
          patientName,
          patientLastName,
          patientRut,
          `${medicine.name.data.name}\n\n${indication}`
        );
      }
    })
    .catch((error) => {
      console.log(`error response receta ${logAction}`, error)

      dispatch(setShowAlertMedicineTrue(false));
      errorAlert(
        `No se pudo crear la Receta ${logAction}, notificarlo al Área de TI`
      );
      getIP().then((response) => {
        enviarLogErrorCreatePrescription(
          action,
          error.toString(),
          profRut,
          profName,
          patientRut,
          patientName,
          patientLastName,
          response.data
        );
      });
    });
};

const logRecemed = (
  action,
  control,
  response,
  professionalName,
  professionalRut,
  patientName,
  patientLastName,
  patientRut,
  medicine
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let date = new Date();

  db.collection("logRecemed").add({
    log_date: date,
    action,
    control,
    response: { ...response.data },
    professionalRut,
    professionalName,
    patientRut,
    patientName: `${patientName.trim()} ${patientLastName.trim()}`,
    medicine,
  });
};

const logRecemedProcedureExam = (
  action,
  response,
  professionalName,
  professionalRut,
  patientName,
  patientLastName,
  patientRut,
  detail,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let date = new Date();

  db.collection("logRecemed").add({
    log_date: date,
    action,
    response: { ...response.data },
    professionalRut,
    professionalName,
    patientRut,
    patientName: `${patientName.trim()} ${patientLastName.trim()}`,
    detail,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

const logRecemedErrorProcedureExam = (
  action,
  error,
  professionalName,
  professionalRut,
  patientName,
  patientLastName,
  patientRut,
  detail,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let date = new Date();

  db.collection("logRecemed").add({
    log_date: date,
    action,
    error,
    professionalRut,
    professionalName,
    patientRut,
    patientName: `${patientName.trim()} ${patientLastName.trim()}`,
    detail,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

// Método para crear procedimientos en RECEMED
const createProcedure = (
  idMedico,
  idPaciente,
  detalle,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  return new Promise((resolve, reject) => {
    const data = {
      idMedico,
      idPaciente,
      detalle,
    };

    axios
      .post(`${urlServer}/recemed/addprocedimiento`, data)
      .then((response) => {
        // if (response.data.statusCode === 500) {
        if (response.data.error) {
          dispatch(setShowAlertMedicineTrue(false));
          // errorAlert('No se pudo crear el Procedimiento, notificarlo al Área de TI');
          errorAlert(response.data.error.mensaje);
          getIP().then((responseIP) => {
            logRecemedErrorProcedureExam(
              "[Recemed] Create Procedure",
              { ...response.data.error.error },
              profName,
              profRut,
              patientName,
              patientLastName,
              patientRut,
              detalle,
              responseIP.data
            );
          });
        } else {
          dispatch(setShowAlertMedicineTrue(false));
          getIP().then((responseIP) => {
            logRecemedProcedureExam(
              "[Create Procedure]",
              response,
              profName,
              profRut,
              patientName,
              patientLastName,
              patientRut,
              detalle,
              responseIP.data
            );
          });
          resolve({ status: 200, msg: "Procedimiento creado con Éxito" });
        }
      })
      .catch((error) => {
        dispatch(setShowAlertMedicineTrue(false));
        errorAlert(
          "No se pudo crear el Procedimiento, notificarlo al Área de TI"
        );
        getIP().then((response) => {
          logRecemedErrorProcedureExam(
            "[Recemed] Create Procedure",
            error.toString(),
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            detalle,
            response.data
          );
        });
      });
  });
};

// Método para crear orden médica en RECEMED
const createOrder = (
  idMedico,
  idPaciente,
  detalle,
  observaciones,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  return new Promise((resolve, reject) => {
    const data = {
      idMedico,
      idPaciente,
      detalle,
      observaciones,
    };

    axios
      .post(`${urlServer}/recemed/addexamen`, data)
      .then((response) => {
        if (response.data.error) {
          dispatch(setShowAlertMedicineTrue(false));
          // errorAlert('No se pudo crear la Orden Médica, notificarlo al Área de TI');
          errorAlert(response.data.error.mensaje);

          getIP().then((responseIP) => {
            logRecemedErrorProcedureExam(
              "[Recemed] Create Order",
              { ...response.data.error.error },
              profName,
              profRut,
              patientName,
              patientLastName,
              patientRut,
              `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
              responseIP.data
            );
          });
        } else {
          dispatch(setShowAlertMedicineTrue(false));
          getIP().then((responseIP) => {
            logRecemedProcedureExam(
              "[Create Order]",
              response,
              profName,
              profRut,
              patientName,
              patientLastName,
              patientRut,
              `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
              responseIP.data
            );
          });
          resolve({ status: 200, msg: "Órden Médica creada con Éxito", response });
        }
      })
      .catch((error) => {
        dispatch(setShowAlertMedicineTrue(false));
        errorAlert(
          "No se pudo crear la Orden Médica, notificarlo al Área de TI"
        );
        getIP().then((response) => {
          logRecemedErrorProcedureExam(
            "[Recemed] Create Order",
            error.toString(),
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
            response.data
          );
        });
      });
  });
};

// Método para crear orden médica en RECEMED
const createOrderFromRecord = (
  idMedico,
  idPaciente,
  order,
  detalle,
  observaciones,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch,
  dataAppointment
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  const data = {
    idMedico,
    idPaciente,
    detalle,
    observaciones,
  };

  axios
    .post(`${urlServer}/recemed/addexamen`, data)
    .then((response) => {
      if (response.data.error) {
        dispatch(setShowAlertOrderTrue(false));
        // errorAlert('No se pudo crear la Orden Médica, notificarlo al Área de TI');
        errorAlert(response.data.error.mensaje);

        getIP().then((responseIP) => {
          logRecemedErrorProcedureExam(
            "[Recemed] Create Order",
            { ...response.data.error.error },
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
            responseIP.data
          );
        });
      } else {
        // if (dataAppointment.notify) {
        //   const idDocument = dataAppointment.idDocument;
        //   const dni = patientRut;
        //   const timestamp = dataAppointment.timestamp;

        //   const dataToExamed = {
        //     RUT_PAC: dataAppointment.patientDNI,
        //     DNI_PAC: "",
        //     NOM_PAC: dataAppointment.patientName,
        //     APE_PAC: dataAppointment.patientLastName,
        //     Sexo: dataAppointment.patientGender,
        //     ID_NAC: dataAppointment.patientNationality,
        //     Fecha_Nac: dataAppointment.patientBirth,
        //     Direccion: dataAppointment.patientAddress,
        //     Telefono: dataAppointment.patientPhone,
        //     Correo: dataAppointment.patientEmail,
        //     ID_COM: dataAppointment.patientCity,
        //     OBS: dataAppointment.medicalOrderDetail,
        //     ID_HOST_PROFESIONAL: dataAppointment.host,
        //     RUT_Profesional: dataAppointment.professionalDNI,
        //     Nombre_Profesional: dataAppointment.professionalName,
        //     Apellido_Profesional: dataAppointment.professionalLastName,
        //     Examenes: dataAppointment.medicalOrders,
        //     idDocument: dataAppointment.idDocument,
        //     timestamp: dataAppointment.timestamp
        //   };

        //   const responseOrdenes = response.data;

        //   axios.post(`${urlServer}/examed/examsEnqueueTask`, {
        //     idDocument,
        //     dni,
        //     timestamp,
        //     ...dataToExamed,
        //     Examenes: order,
        //     orderToArray: {
        //       order: responseOrdenes,
        //       orderName: {
        //         detalle,
        //         observaciones,
        //       }
        //     }
        //   });
        // }
        dispatch(setShowAlertOrderTrue(false));
        successAlert("Órden Médica creada con Éxito");
        getIP().then((responseIP) => {
          logRecemedProcedureExam(
            "[Create Order]",
            response,
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
            responseIP.data
          );
        });
      }
    })
    .catch((error) => {
      dispatch(setShowAlertOrderTrue(false));
      errorAlert("No se pudo crear la Orden Médica, notificarlo al Área de TI");

      getIP().then((response) => {
        logRecemedErrorProcedureExam(
          "[Recemed] Create Order",
          error.toString(),
          profName,
          profRut,
          patientName,
          patientLastName,
          patientRut,
          `Órden Médica: ${detalle}\nDetalle Orden: ${observaciones}`,
          response.data
        );
      });
    });
};

// Método para crear orden médica en RECEMED
const createProcedureFromRecord = (
  idMedico,
  idPaciente,
  detalle,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  dispatch
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  const data = {
    idMedico,
    idPaciente,
    detalle,
  };

  axios
    .post(`${urlServer}/recemed/addprocedimiento`, data)
    .then((response) => {
      // if (response.data.statusCode === 500) {
      if (response.data.error) {
        dispatch(setShowAlertProcedureTrue(false));
        // errorAlert('No se pudo crear el Procedimiento, notificarlo al Área de TI');
        errorAlert(response.data.error.mensaje);

        getIP().then((responseIP) => {
          logRecemedErrorProcedureExam(
            "[Recemed] Create Procedure",
            { ...response.data.error.error },
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            detalle,
            responseIP.data
          );
        });
      } else {
        dispatch(setShowAlertProcedureTrue(false));
        successAlert("Procedimiento creado con Éxito");

        getIP().then((responseIP) => {
          logRecemedProcedureExam(
            "[Create Procedure]",
            response,
            profName,
            profRut,
            patientName,
            patientLastName,
            patientRut,
            detalle,
            responseIP.data
          );
        });
      }
    })
    .catch((error) => {
      dispatch(setShowAlertProcedureTrue(false));
      errorAlert(
        "No se pudo crear el Procedimiento, notificarlo al Área de TI"
      );

      getIP().then((response) => {
        logRecemedErrorProcedureExam(
          "[Recemed] Create Procedure",
          error.toString(),
          profName,
          profRut,
          patientName,
          patientLastName,
          patientRut,
          detalle,
          response.data
        );
      });
    });
};

//Método para actualizar la ficha en la BD
export const updateRecord = (values, id) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;
  const storage = reduxState.companyInstance.storage;

  let data = {
    patientRut: values.rut,
    patientName: values.name,
    patientLastName: values.lastname,
    patientSocialName: values.social_name,
    patientBirthDate: values.date,
    patientAge: values.age,
    patientGender: values.gender,
    patientNationality: values.nationality,
    patientResidenceCountry: values.residence_country,
    patientAddress: values.address,
    patientRegion: values.region,
    patientComunne: values.commune,
    patientCity: values.city,
    patientNameContact: values.contact,
    patientNumberContact: values.number_contact,
    patientContactEmail: values.email_contact,
    patientEducation: values.education,
    createDate: values.create_date2,
    patientOccupation: values.occupation,
    patientMedicalPlan: values.medical_plan,
    patientCivilState: values.civil_state,
    patientAlta: values.alta,
    patientDateAlta: values.date_alta,
    patientUserAlta: values.user_alta,
  };

  let dataAttention = {
    reasonConsultation: values.reasonConsultation,
    physicalExam: values.physicalExam,
    past: values.past,
    anamnesis: values.anamnesis,
    diagnosis: values.diagnosis,
    medicines: values.medicinesPatient,
    medicalOrders: values.medicalOrders,
    resume: values.resume,
    medicalLicense: values.medicalLicense,
    days: values.nextControl,
    dateControl: values.dateControl,
    derivation: values.checked,
  };

  return async (dispatch) => {
    db.collection("attention")
      .doc(`${id}`)
      .update({
        typeConsult: values.typeConsult,
        patientInfo: data,
        attention: dataAttention,
        professionalName: values.professionalName,
        professionalRut: values.professionalRut,
        urlFiles: values.urlFiles,
        pathFiles: values.pathFiles,
      })
      .then((docRef) => {
        dispatch(
          openModalLog(types.doctorUpdateRecord, values.professionalRut, id)
        );
        values.deleteFiles.forEach((file) => {
          let ref = storage.child(file.path);
          ref
            .delete()
            .then(function () {
              // File deleted successfully
              console.log("Se eliminó el archivo");
            })
            .catch(function (error) {
              console.log("Hubo un error");
            });
        });

        dispatch(clearMed());
        Swal.fire({
          position: "center",
          icon: "success",
          allowOutsideClick: false,
          title: "Se Actualizó la Ficha con Éxito",
          showConfirmButton: false,
          timer: 1300,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };
};

//Método para agregar una medicina
export const addNewMed = (medicine) => ({
  type: types.doctorAddMedicine,
  payload: {
    ...medicine,
  },
});

//Método para recargar todas las medicinas
export const addReloadMed = (medicine) => ({
  type: types.doctorReloadAddMedicine,
  payload: medicine,
});

export const addMedInUpdate = (medicine) => ({
  type: types.doctorAddMedicineInUpdate,
  payload: medicine,
});

//Método para remover una medicina del estado
export const removeMed = (id) => ({
  type: types.doctorRemoveOneMedicine,
  payload: id,
});

//Método para limpiar el estado de las medicinas
export const clearMed = () => ({
  type: types.doctorClearMedicines,
});

//Método para agregar un documento
export const addNewDoc = (doc) => ({
  type: types.doctorAddDocument,
  payload: {
    ...doc,
  },
});

//Método para remover un documento del estado
export const removeDoc = (name) => ({
  type: types.doctorRemoveOneDocument,
  payload: name,
});

//Método para limpiar el estado de los documents
export const clearDoc = () => ({
  type: types.doctorClearDocuments,
});

// //Método para set las citas en el estado myDates
export const setMyDates = (dates) => ({
  type: types.myDatesLoad,
  payload: dates,
});

//Método para set las citas peritajes en el estado myDatesPeritaje
export const setMyDatesPeritaje = (dates) => ({
  type: types.myDatesPeritajeLoad,
  payload: dates,
});

//Método que Set un paciente en el estado Active
export const activePatient = (id, patient) => ({
  type: types.doctorPatientActive,
  payload: {
    id,
    ...patient,
  },
});

//Método que Set un paciente en el estado Active
export const activePatientFromRecord = (schedule) => ({
  type: types.doctorPatientActive,
  payload: { ...schedule },
});

//Método para llamar el type para limpiar el estado Active
export const startCleanActive = () => {
  return async (dispatch) => {
    dispatch(cleanActive());
  };
};

//Método para limpiar el estado Active
export const cleanActive = () => ({
  type: types.doctorPatientActiveClean,
});

//Método para iniciar la limpieza del Estado
export const startCleanDoctor = () => {
  return async (dispatch) => {
    dispatch(cleanDoctor());
  };
};

//Método que llama el type para limpiar el Estado
export const cleanDoctor = () => ({
  type: types.cleanDoctor,
});

//Método para detectar si se abre un modal y llamar al Log para registrar la acción
export const openModalLog = (type, uid, id) => {
  return async (dispatch) => {
    //Realiza la acción que coincida con ese type
    dispatch({ type: type });
  };
};

//Método para detectar si se cierra un modal y llamar al Log para registrar la acción
export const closeModalLog = (uid, id) => {
  return async (dispatch) => {
    //Realiza la acción que coincida con ese type
    dispatch({ type: types.closeModalAddRecord });
  };
};

//Método para set las fichas medicas en el estado records
export const setMyRecords = (records) => ({
  type: types.myRecordsLoad,
  payload: records,
});

//Método para set los pacientes en el estado patients
export const setMyPatients = (records) => ({
  type: types.myPatientsLoad,
  payload: records,
});

export const setCountriesProf = (countries) => ({
  type: types.loadCountriesProf,
  payload: countries,
});

//Método para cambiar el estado y mostrar el mensaje de creando Receta
export const setShowAlertMedicineTrue = (show) => ({
  type: types.doctorActiveAlertMedicine,
  payload: show,
});

//Método para cambiar el estado y mostrar el mensaje de creando Órden Médica
export const setShowAlertOrderTrue = (show) => ({
  type: types.doctorActiveAlertOrder,
  payload: show,
});

//Método para cambiar el estado y mostrar el mensaje de creando Procedimiento
export const setShowAlertProcedureTrue = (show) => ({
  type: types.doctorActiveAlertProcedure,
  payload: show,
});

export const setFinishCreateRecordTrue = (finish) => ({
  type: types.doctorFinishCreateRecord,
  payload: finish,
});

//Método para limpiar el historial del paciente
export const clearHistory = () => ({
  type: types.doctorActiveHistoryClean,
});

export const createIndividualReceta = (
  formik,
  docs,
  setDocs,
  user_profile,
  footerDocuments,
  medicine
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;
  const { permissionRecemed, permissionPrescription } = reduxState.permissionsIntegrations;
  const values = formik.values;
  return async (dispatch) => {


    if (permissionRecemed) {
      //Realiza la acción que coincida con ese type
      dispatch(setShowAlertMedicineTrue(true));

      let idDoctorRecemed;
      let idPatientRecemed;

      const patientName =
        `${values.patientNameFirst} ${values.patientNameSecond}`.trim();
      const patientLastName =
        `${values.patientNameFirstLastName} ${values.patientNameSecondLastName}`.trim();

      const professionalRut = values.professionalDNI;

      let data = {
        idDocument: values.idDocument,
        patientDNI: values.patientDNI,
        patientNameFirst: values.patientNameFirst,
        patientNameSecond: values.patientNameSecond,
        patientNameFirstLastName: values.patientNameFirstLastName,
        patientNameSecondLastName: values.patientNameSecondLastName,
        patientName: patientName,
        patientLastName: patientLastName,
        patientSocialName: values.patientNameSocial.trim().toUpperCase(),
        patientEmail: values.patientEmail.trim(),
        patientPhone: values.patientPhoneComplete.trim(),
        patientBirthDate: values.patientBirth,
        patientAge: values.patientAge,
        patientGender: values.patientGender,
        patientNationality: values.patientNationality,
        patientResidenceCountry: values.patientResidenceCountry,
        patientAddress: values.patientAddress.trim().toUpperCase(),
        patientRegionId: values.patientRegionId,
        patientRegion: values.patientRegion,
        patientCityId: values.patientCityId,
        patientCity: values.patientCity,
        patientNameContact: values.patientContactName.trim().toUpperCase(),
        patientNumberContact: values.patientContactPhone.trim(),
        patientContactEmail: values.patientContactEmail.trim(),
        patientEducation: values.patientEducation,
        createDate: values.createDate,
        patientOccupation: values.patientOccupation.trim().toUpperCase(),
        patientMedicalPlan: values.patientPlanMedicalName,
        patientCivilState: values.patientCivilState,
        timestamp: values.timestamp,
        notify: values.notify ?? false
      };

      ///////////////////////////////////////////////////// INICIO /////////////////////////////////////////////////////
      axios
        .get(`${urlServer}/recemed/medicoid/${professionalRut}`)
        .then((response) => {
          idDoctorRecemed = response.data.id;

          getIDPaciente(data)
            .then((response) => {
              console.log("response id paciente", response)
              idPatientRecemed = response;

              ///////////////////////////////////////////// INICIO RECETA RECEMED /////////////////////////////////////////////
              createRecetaFromRecord(
                data.patientMedicalPlan,
                idDoctorRecemed,
                idPatientRecemed,
                medicine,
                false,
                values.professionalDNI,
                values.professionalNameComplete,
                values.patientDNI,
                patientName,
                patientLastName,
                dispatch,
                data
              );
              ///////////////////////////////////////////// FIN RECETA RECEMED ///////////////////////////////////////////////
            })
            .catch((error) => {
              console.log("error response id paciente", error)

              getIP().then((response) => {
                enviarLogErrorIntegrationsFromRecord(
                  "[Recemed] Get ID Patient",
                  error.toString(),
                  values.professionalDNI,
                  response.data,
                  values.patientDNI,
                  values.timestamp
                );
              });
            });
        })
        .catch((error) => {
          getIP().then((response) => {
            enviarLogErrorIntegrationsFromRecord(
              "[Recemed] Get ID Professional",
              error.toString(),
              values.professionalRut,
              response.data,
              values.patientRut,
              values.timestamp
            );
          });
        });
      ///////////////////////////////////////////////////// FIN /////////////////////////////////////////////////////}
    };

    if (permissionPrescription) {

      dispatch(
        generatePdfMedicinesCL(
          footerDocuments,
          formik,
          formik.values.medicinesPatient,
          user_profile,
          docs,
          setDocs
        )
      );

    }
  };
};

export const createIndividualOrder = (
  formik,
  order,
  medicalOrderDetail,
  docs,
  setDocs,
  user_profile,
  footerDocuments
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;
  const { permissionRecemed, permissionOrderProcedures } = reduxState.permissionsIntegrations;
  const values = formik.values;

  return async (dispatch) => {

    if (permissionRecemed) {
      //Realiza la acción que coincida con ese type
      dispatch(setShowAlertOrderTrue(true));

      let idDoctorRecemed;
      let idPatientRecemed;

      let data = {
        idDocument: values.idDocument,
        patientDNI: values.patientDNI,
        patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
        patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
        patientNameFirstLastName: values.patientNameFirstLastName.trim().toUpperCase(),
        patientNameSecondLastName: values.patientNameSecondLastName.trim().toUpperCase(),
        patientName: values.patientNameComplete.trim().toUpperCase(),
        patientLastName: values.patientLastNameComplete.trim().toUpperCase(),
        patientSocialName: values.patientNameSocial.trim().toUpperCase(),
        patientEmail: values.patientEmail.trim(),
        patientPhone: values.patientPhoneComplete.trim(),
        patientBirthDate: values.patientBirth,
        patientAge: values.patientAge,
        patientGender: values.patientGender,
        patientNationality: values.patientNationality,
        patientResidenceCountry: values.patientResidenceCountry,
        patientAddress: values.patientAddress.trim().toUpperCase(),
        patientRegionId: values.patientRegionId,
        patientRegion: values.patientRegion,
        patientCityId: values.patientCityId,
        patientCity: values.patientCity,
        patientNameContact: values.patientContactName.trim().toUpperCase(),
        patientNumberContact: values.patientContactPhoneComplete.trim(),
        patientContactEmail: values.patientContactEmail.trim(),
        patientEducation: values.patientEducation,
        createDate: values.createDate,
        patientOccupation: values.patientOccupation.trim().toUpperCase(),
        patientMedicalPlan: values.patientPlanMedicalName,
        patientCivilState: values.patientCivilState,
        timestamp: values.timestamp,
        notify: values.notify ?? false
      };

      const diagnosis = values.diagnosis.label;

      let orderString = `${diagnosis}\n\n`;
      if (typeof (order) === "string") {
        orderString += order;
      } else {
        order.forEach((ord) => {
          orderString += `\n${ord.examen}`;
        });
      }

      ///////////////////////////////////////////////////// INICIO /////////////////////////////////////////////////////
      axios
        .get(`${urlServer}/recemed/medicoid/${values.professionalDNI}`)
        .then((response) => {
          idDoctorRecemed = response.data.id;
          getIDPaciente(data)
            .then((response) => {
              idPatientRecemed = response;
              ///////////////////////////////////////////// INICIO ORDEN /////////////////////////////////////////////
              createOrderFromRecord(
                idDoctorRecemed,
                idPatientRecemed,
                order,
                orderString,
                medicalOrderDetail,
                values.professionalDNI,
                values.professionalNameComplete,
                values.patientDNI,
                values.patientNameComplete,
                values.patientLastNameComplete,
                dispatch,
                data
              );
              ///////////////////////////////////////////// FIN ORDEN ///////////////////////////////////////////////
            })
            .catch((error) => {
              getIP().then((response) => {
                enviarLogErrorIntegrationsFromRecord(
                  "[Recemed] Get ID Patient",
                  error.toString(),
                  values.professionalDNI,
                  response.data,
                  values.patientDNI,
                  values.timestamp
                );
              });
            });
        })
        .catch((error) => {
          getIP().then((response) => {
            enviarLogErrorIntegrationsFromRecord(
              "[Recemed] Get ID Patient",
              error.toString(),
              values.professionalRut,
              response.data,
              values.patientRut,
              values.timestamp
            );
          });
        });
      ///////////////////////////////////////////////////// FIN /////////////////////////////////////////////////////
    }

    if (permissionOrderProcedures) {
      dispatch(
        generatePdfOrdersCL(
          footerDocuments,
          formik,
          formik.values.medicalOrders,
          user_profile,
          docs,
          setDocs
        )
      );
    }
  };
};

export const createIndividualProcedure = (
  formik,
  detalle,
  docs,
  setDocs,
  user_profile,
  footerDocuments
) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;
  const { permissionRecemed, permissionOrderProcedures } = reduxState.permissionsIntegrations;
  const values = formik.values;

  return async (dispatch) => {

    if (permissionRecemed) {
      //Realiza la acción que coincida con ese type
      dispatch(setShowAlertProcedureTrue(true));

      let idDoctorRecemed;
      let idPatientRecemed;

      let data = {
        patientDNI: values.patientDNI,
        patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
        patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
        patientNameFirstLastName: values.patientNameFirstLastName.trim().toUpperCase(),
        patientNameSecondLastName: values.patientNameSecondLastName.trim().toUpperCase(),
        patientName: values.patientNameComplete.trim().toUpperCase(),
        patientLastName: values.patientLastNameComplete.trim().toUpperCase(),
        patientSocialName: values.patientNameSocial.trim().toUpperCase(),
        patientEmail: values.patientEmail.trim(),
        patientPhone: values.patientPhoneComplete.trim(),
        patientBirthDate: values.patientBirth,
        patientAge: values.patientAge,
        patientGender: values.patientGender,
        patientNationality: values.patientNationality,
        patientResidenceCountry: values.patientResidenceCountry,
        patientAddress: values.patientAddress.trim().toUpperCase(),
        patientRegionId: values.patientRegionId,
        patientRegion: values.patientRegion,
        patientCityId: values.patientCityId,
        patientCity: values.patientCity,
        patientNameContact: values.patientContactName.trim().toUpperCase(),
        patientNumberContact: values.patientContactPhoneComplete.trim(),
        patientContactEmail: values.patientContactEmail.trim(),
        patientEducation: values.patientEducation,
        createDate: values.createDate,
        patientOccupation: values.patientOccupation.trim().toUpperCase(),
        patientMedicalPlan: values.patientPlanMedicalName,
        patientCivilState: values.patientCivilState,
      };

      ///////////////////////////////////////////////////// INICIO /////////////////////////////////////////////////////
      axios
        .get(`${urlServer}/recemed/medicoid/${values.professionalDNI}`)
        .then((response) => {
          idDoctorRecemed = response.data.id;
          getIDPaciente(data)
            .then((response) => {
              idPatientRecemed = response;
              ///////////////////////////////////////////// INICIO PROCEDIMIENTO /////////////////////////////////////////////
              createProcedureFromRecord(
                idDoctorRecemed,
                idPatientRecemed,
                detalle,
                values.professionalDNI,
                values.professionalNameComplete,
                values.patientDNI,
                values.patientNameComplete,
                values.patientLastNameComplete,
                dispatch
              );
              ///////////////////////////////////////////// FIN PROCEDIMIENTO ///////////////////////////////////////////////
            })
            .catch((error) => {
              getIP().then((response) => {
                enviarLogErrorIntegrationsFromRecord(
                  "[Recemed] Get ID Patient",
                  error.toString(),
                  values.professionalDNI,
                  response.data,
                  values.patientDNI,
                  values.timestamp
                );
              });
            });
        })
        .catch((error) => {
          getIP().then((response) => {
            enviarLogErrorIntegrationsFromRecord(
              "[Recemed] Get ID Patient",
              error.toString(),
              values.professionalRut,
              response.data,
              values.patientRut,
              values.timestamp
            );
          });
        });
      ///////////////////////////////////////////////////// FIN /////////////////////////////////////////////////////
    }

    if (permissionOrderProcedures) {
      dispatch(
        generatePdfProceduresCL(
          footerDocuments,
          formik,
          detalle,
          user_profile,
          docs,
          setDocs
        )
      );
    }
  };
};

/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////

//Método para guardar el Log cuando se crea una Ficha
// const enviarLogDoctorAddRecord = (
//   action,
//   profRut,
//   profName,
//   patientRut,
//   patientName,
//   patientLastName,
//   idDocument,
//   IP
// ) => {
//   //Se crea la fecha actual en la que se crea el Log
//   let date = new Date();

//   //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
//   db.collection("log")
//     .add({
//       log_date: date,
//       action: action,
//       professionalRut: profRut,
//       professional: profName,
//       patientRut: patientRut,
//       patient: `${patientName} ${patientLastName}`,
//       idDocument: idDocument,
//       ip: IP.IPv4,
//       country: IP.country_name,
//     })
//     .then((docRef) => { })
//     .catch((error) => { });
// };

//Método para guardar el Log cuando se crea una Ficha
const enviarLogDoctorErrorAddRecord = (
  action,
  error,
  profDNI,
  profName,
  patientDNI,
  patientName,
  patientLastName,
  idDocument,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      error: error,
      professionalDNI: profDNI,
      professional: profName,
      patientDNI: patientDNI,
      patient: `${patientName} ${patientLastName}`,
      idDocument: idDocument,
      ip: IP ? IP.IPv4 : "",
      country: IP ? IP.country_name : "",
    })
    .then((docRef) => { })
    .catch((error) => { });
};

//Método para guardar el Log cuando se activa un BONO
const enviarLogDoctorBonoActivation = (
  action,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  responseFonasa,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      professionalRut: profRut,
      professional: profName,
      patientRut: patientRut,
      patient: `${patientName} ${patientLastName}`,
      id_bono: responseFonasa.id_bono,
      folio: responseFonasa.folio,
      ip: IP.IPv4,
      country: IP.country_name,
    })
    .then((docRef) => { })
    .catch((error) => { });
};

//Método para guardar el Log cuando se activa un BONO
const enviarLogDoctorErrorBonoActivation = (
  action,
  error,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  id_atencion,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      error: error,
      professionalRut: profRut,
      professional: profName,
      patientRut: patientRut,
      patient: `${patientName} ${patientLastName}`,
      id_atencion: id_atencion,
      ip: IP.IPv4,
      country: IP.country_name,
    })
    .then((docRef) => { })
    .catch((error) => { });
};

//Método para guardar el Log cuando se crean derivaciones
const enviarLogErrorDoctorAddDerivations = (
  action,
  error,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  idDocument,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    professionalRut: profRut,
    professional: profName,
    patientRut: patientRut,
    patient: `${patientName} ${patientLastName}`,
    idDocument: idDocument,
    ip: IP ? IP.IPv4 : "",
    country: IP ? IP.country_name : "",
  });
};

//Método para guardar el Log Error cuando se crea una Ficha
const enviarLogErrorIntegrations = (
  action,
  error,
  professionalID,
  IP,
  patientID,
  timestamp,
  timezone
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("logRecemed").add({
    log_date: date,
    action: action,
    error: error,
    professional: professionalID,
    patient: patientID,
    ip: IP.IPv4,
    country: IP.country_name,
    timeStart: getDateCorregidoZonaHoraria(new Date(timestamp), timezone),
  });
};

const enviarLogErrorIntegrationsFromRecord = (
  action,
  error,
  professionalID,
  IP,
  patientID,
  timestamp
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("logRecemed").add({
    log_date: date,
    action: action,
    error: error,
    professional: professionalID,
    patient: patientID,
    ip: IP.IPv4,
    country: IP.country_name,
    timeStart: new Date(timestamp),
  });
};

//Método para guardar el Log Error cuando se crea Receta
const enviarLogErrorCreatePrescription = (
  action,
  error,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("logRecemed").add({
    log_date: date,
    action: action,
    error: error,
    professional: profRut,
    professionalName: profName,
    patient: patientRut,
    patientName: `${patientName} ${patientLastName}`,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log Error cuando se crea Licencia Medica
const enviarLogErrorMedipassLicense = (
  action,
  error,
  profRut,
  patientRut,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    professional: profRut,
    patient: patientRut,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log Error cuando se crea Notifica a Fonasa
const enviarLogErrorNotifyFonasa = (
  action,
  error,
  profRut,
  patientRut,
  id_atencion,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    professional: profRut,
    patient: patientRut,
    id_atencion: id_atencion,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log Error cuando se crea Notifica a Fonasa
const enviarLogNotifyResume = (
  action,
  msg,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    msg: msg,
    professional: profRut,
    professionalName: profName,
    patient: patientRut,
    patientName: `${patientName} ${patientLastName}`,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log cuando se envía resumen atención
const enviarLogNotifyResume2 = (
  action,
  msg,
  professionalDNI,
  professionalName,
  patientDNI,
  patientName,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  // Se registra en la colección el Log, almacenando la fecha de la acción, la acción, la respuesta obtenida y el email al cual se envía la información
  db.collection("log").doc("logSchedule").collection("resumeSchedule").add({
    log_date: date,
    action: action,
    msg: msg,
    professionalDNI,
    professionalName,
    patientDNI,
    patientName,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log Error cuando se crea Notifica a Fonasa
const enviarLogErrorNotifyResume = (
  action,
  error,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    professional: profRut,
    professionalName: profName,
    patient: patientRut,
    patientName: `${patientName} ${patientLastName}`,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

// Método para guardar el Log Error cuando se envía resumen atención
const enviarLogErrorNotifyResume2 = (
  action,
  error,
  professionalDNI,
  professionalName,
  patientDNI,
  patientName,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").doc("logSchedule").collection("resumeSchedule").add({
    log_date: date,
    action: action,
    error: error,
    professionalDNI,
    professionalName,
    patientDNI,
    patientName,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log del Doctor cuando abre alguno de los modales para agregar, editar o ver la ficha médica
const enviarLogDoctorOpenModal = (type, uid, id) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: type,
      user: uid,
      type: id,
    })
    .then((docRef) => { })
    .catch((error) => { });
};

//Método para guardar el Log de los errores del Doctor
const enviarLogErrorDoctor = (action, error, uid) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      error: error,
      user: uid,
    })
    .then((docRef) => { })
    .catch((error) => { });
};
/////////////////////////////////////////////////////MÉTODOS PARA LOGS////////////////////////////////////////////////////

//Método para agregar la ficha creada desde cero a la BD
export const addRecord = (values) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let date = new Date();

  let data = {
    patientRut: values.rut,
    patientName: values.name,
    patientLastName: values.lastname,
    patientSocialName: values.social_name,
    patientBirthDate: values.date,
    patientAge: values.age,
    patientGender: values.gender,
    patientNationality: values.nationality,
    patientResidenceCountry: values.residence_country,
    patientAddress: values.address,
    patientRegion: values.region,
    patientComunne: values.commune,
    patientCity: values.city,
    patientNameContact: values.contact,
    patientNumberContact: values.number_contact,
    patientContactEmail: values.email_contact,
    patientEducation: values.education,
    createDate: date,
    patientOccupation: values.occupation,
    patientMedicalPlan: values.medical_plan,
    patientCivilState: values.civil_state,
    patientAlta: values.alta,
    patientDateAlta: values.date_alta,
    patientUserAlta: values.user_alta,
  };

  let dataAttention = {
    reason_consult: values.reason_consultation,
    physical_exam: values.physical_exam,
    past: values.past,
    anamnesis: values.anamnesis,
    diagnosis: values.diagnosis,
    medicines: values.medicines_patient,
    medicalOrders: values.medical_orders,
    resume: values.resume,
    medicalLicense: values.medical_license,
    days: values.next_control,
    dateControl: values.date_control,
    derivation: values.checked,
  };

  return async (dispatch) => {
    db.collection("attention")
      .add({
        typeConsult: values.consult,
        patientInfo: data,
        attention: dataAttention,
        fullnameDoctor: values.fullname_doctor,
        rutDoctor: values.rut_doctor,
        urlFiles: values.urls_files,
        pathFiles: values.path_files,
        dateConsult: "",
      })
      .then((docRef) => {
        dispatch(
          openModalLog(types.doctorAddNewRecord, values.rut_doctor, docRef.id)
        );
        Swal.fire({
          position: "center",
          icon: "success",
          allowOutsideClick: false,
          title: "Se agregó la Ficha con Éxito",
          showConfirmButton: false,
          timer: 1300,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        dispatch(clearMed());
      })
      .catch((error) => { });
  };
};

//Método para crear la ficha cuando el doctor presiona el botón de ingresar a la consulta
export const addRecordFirstTime = (values) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let date = new Date();

  let data = {
    rutPatient: values.rut,
    namePatient: values.firstName.trim() + " " + values.secondName.trim(),
    lastNamePatient:
      values.firstLastName.trim() + " " + values.secondLastName.trim(),
    socialNamePatient: values.social_name,
    birthDatePatient: values.date,
    agePatient: "",
    genderPantient: values.gender,
    nationalityPatient: values.nationality,
    residenceCountryPatient: values.country,
    addressPatient: values.address,
    regionPatient: values.region,
    communePatient: values.commune,
    cityPatient: values.city,
    nameContactPatient: values.contact,
    numberContactPatient: values.number_contact,
    emailContactPatient: values.email_contact,
    educationPatient: values.education,
    createDate: date,
    occupationPatient: values.occupation,
    medicalPlanPatient: values.medical_plan,
    civilStatePatient: values.civil_state,
    altaPatient: "",
    dateAltaPatient: "",
    userAltaPatient: "",
  };

  let dataAttention = {
    reasonConsult: "",
    physicalExam: "",
    past: "",
    anamnesis: "",
    diagnosis: "",
    medicines: [],
    medicalOrders: [],
    resume: "",
    medicalLicense: false,
    days: "",
    dateControl: "",
    derivation: "",
  };

  const docRef = db.collection("attention").doc(values.idDocument);

  docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        console.log("Document data:", doc.data());
      } else {
        db.collection("attention").doc(values.idDocument).set({
          typeConsult: "",
          infoPatient: data,
          attention: dataAttention,
          fullNameDoctor: values.nameDoctor,
          rutDoctor: values.rutDoctor,
          urlFiles: [],
          pathFiles: [],
          dateConsult: values.timeDatePeritaje,
        });
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
};

//Método para agregar la ficha consumiendo consumiendo la data de Schedule y Patient
export const addRecordFromCitas = (values) => {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;
  const urlServer = reduxState.companyInstance.urlServer;

  let data = {
    patientRut: values.patientRut,
    patientNameFirst: values.patientNameFirst.trim().toUpperCase(),
    patientNameSecond: values.patientNameSecond.trim().toUpperCase(),
    patientNameFirstLastName: values.patientNameFirstLastName.trim().toUpperCase(),
    patientNameSecondLastName: values.patientNameSecondLastName.trim().toUpperCase(),
    patientName: values.patientName.trim().toUpperCase(),
    patientLastName: values.patientLastName.trim().toUpperCase(),
    patientSocialName: values.patientSocialName.trim().toUpperCase(),
    patientEmail: values.patientEmail.trim(),
    patientPhone: values.patientPhoneComplete.trim(),
    patientBirthDate: values.patientBirthDate,
    patientAge: values.patientAge,
    patientGender: values.patientGender,
    patientNationality: values.patientNationality,
    patientResidenceCountry: values.patientResidenceCountry,
    patientAddress: values.patientAddress.trim().toUpperCase(),
    patientRegionId: values.patientRegionId,
    patientRegion: values.patientRegion,
    patientCityId: values.patientCityId,
    patientCity: values.patientCity,
    patientNameContact: values.patientNameContact.trim().toUpperCase(),
    patientNumberContact: values.patientNumberContact.trim(),
    patientContactEmail: values.patientContactEmail.trim(),
    patientEducation: values.patientEducation,
    createDate: values.createDate,
    patientOccupation: values.patientOccupation.trim().toUpperCase(),
    patientMedicalPlan: values.patientMedicalPlan,
    patientCivilState: values.patientCivilState,
    patientAlta: values.patientAlta,
    patientDateAlta: values.patientDateAlta,
    patientUserAlta: values.patientUserAlta,
  };

  let dataAttention = {
    reasonConsultation: values.reasonConsultation,
    physicalExam: values.physicalExam,
    past: values.past,
    anamnesis: values.anamnesis,
    diagnosis: values.diagnosis,
    medicines: values.medicinesPatient,
    medicalOrders: values.medicalOrders,
    medicalOrderDetail: values.medicalOrderDetail,
    medicalProcedures: values.medicalProcedures,
    resume: values.resume,
    medicalLicense: values.medicalLicense,
    tratNdias: values.tratNdias,
    fechaInicioReposo: values.fechaInicioReposo,
    fechaFinReposo: values.fechaFinReposo,
    days: values.nextControl,
    dateControl: values.dateControl,
    derivation: values.checked,
    descriptionDerivation: values.descriptionDerivation,
    folioLicencia: values.folioLicencia,
    idLicencia: values.payOrder,
  };
  return async (dispatch) => {
    ///////////////////////////////////////////// VALIDACIÓN PARA VER SI DEBEN EMITIR RECETAS, ÓRDENES MÉDICAS O PROCEDIMIENTO MÉDICOS /////////////////////////////////////////////
    if (
      dataAttention.medicines.length > 0 ||
      dataAttention.medicalOrders ||
      dataAttention.medicalProcedures
    ) {
      let idDoctorRecemed;
      let idPatientRecemed;

      axios
        .get(`${urlServer}/recemed/medicoid/${values.professionalRut}`)
        .then((response) => {
          idDoctorRecemed = response.data.id;
          getIDPaciente(data)
            .then((response) => {
              idPatientRecemed = response;

              ///////////////////////////////////////////// INICIO RECETA RECEMED /////////////////////////////////////////////
              if (dataAttention.medicines.length > 0) {
                createReceta(
                  data.patientMedicalPlan,
                  idDoctorRecemed,
                  idPatientRecemed,
                  dataAttention.medicines,
                  false,
                  values.professionalRut,
                  values.professionalName,
                  values.patientRut,
                  values.patientName,
                  values.patientLastName,
                  dispatch
                );
              }
              ///////////////////////////////////////////// FIN RECETA RECEMED ///////////////////////////////////////////////

              ///////////////////////////////////////////// INICIO PROCEDIMIENTO RECEMED /////////////////////////////////////////////
              if (dataAttention.medicalProcedures !== "") {
                const procedures = `${dataAttention.diagnosis.label}\n\n${dataAttention.medicalProcedures}`;
                createProcedure(idDoctorRecemed, idPatientRecemed, procedures);
              }
              ///////////////////////////////////////////// FIN PROCEDIMIENTO RECEMED ////////////////////////////////////////////////

              ///////////////////////////////////////////// INICIO ÓRDEN MÉDICA RECEMED /////////////////////////////////////////////
              if (dataAttention.medicalOrders.length > 0) {
                let order = `${dataAttention.diagnosis.label}\n\n`;
                dataAttention.medicalOrders.forEach((ord) => {
                  order += `\n${ord.examen}`;
                });

                createOrder(
                  idDoctorRecemed,
                  idPatientRecemed,
                  order,
                  dataAttention.medicalOrderDetail
                );
              }
              ///////////////////////////////////////////// INICIO ÓRDEN MÉDICA RECEMED /////////////////////////////////////////////
            })
            .catch((error) => {
              getIP().then((response) => {
                enviarLogErrorIntegrations(
                  "[Recemed] Get ID Professional",
                  error.toString(),
                  values.professionalRut,
                  response.data
                );
              });
            });
        })
        .catch((error) => {
          getIP().then((response) => {
            enviarLogErrorIntegrations(
              "[Recemed] Get ID Professional",
              error.toString(),
              values.professionalRut,
              response.data
            );
          });
        });
    }

    /////////////////////////////////////////// FIN VALIDACIÓN PARA VER SI DEBEN EMITIR RECETAS, ÓRDENES MÉDICAS O PROCEDIMIENTO MÉDICOS ////////////////////////////////////////////

    db.collection("professional")
      .where("dni", "==", values.professionalDNI)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.data());

          const patientsProfessional = doc.data().patient;

          const patientFind = patientsProfessional.filter(
            (patient) =>
              patient.patientRut.trim().toUpperCase() ===
              data.patientRut.trim().toUpperCase()
          );

          if (patientFind.length === 0) {
            db.collection("professional")
              .doc(doc.data().uid)
              .update({
                patient: firebase.firestore.FieldValue.arrayUnion({
                  patientRut: data.patientRut,
                  patientName: `${data.patientName} ${data.patientLastName}`,
                }),
              });
          }

          // console.log(patientFind)
        });
      });

    ///////////////////////////////////////////////// GUARDAR FICHA EN FIREBASE ///////////////////////////////

    // db.collection("attention")
    //   .doc(values.scheduleCountry.toLowerCase())
    //   .collection(values.patientRut)
    //   .doc(values.timestamp.toString())
    //   .set({
    //     typeConsult: values.typeConsult,
    //     typeConsultCode: values.typeConsultCode,
    //     patientInfo: data,
    //     attention: dataAttention,
    //     professionalName: values.professionalName,
    //     professionalRut: values.professionalRut,
    //     pathFiles: values.pathFiles,
    //     timeConsult: values.timeConsult,
    //     startTime: new Date(values.timestamp),
    //     idDocument: values.idDocument,
    //     timestamp: values.timestamp,
    //   })
    //   .then((docRef) => {

    //     moment.locale("es");

    //     const timeSchedule = new Date(values.timestamp).toLocaleString("en-ES", {
    //       timeZone: values.timeZone,
    //     });

    //     const dateSchedule = moment(timeSchedule)
    //       .locale("es")
    //       .format("dddd, D MMMM YYYY");

    //     const hourStartSchedule = moment(timeSchedule)
    //       .locale("es")
    //       .format("h:mma");

    //     const timeScheduleEnd = new Date(timeSchedule);

    //     timeScheduleEnd.setMinutes(
    //       timeScheduleEnd.getMinutes() + values.timeConsult
    //     );

    //     const hourEndSchedule = moment(timeScheduleEnd)
    //       .locale("es")
    //       .format("h:mma");

    //     const dataResume = {
    //       email: values.patientEmail,
    //       patientRut: values.patientRut,
    //       patientName: `${values.patientName} ${values.patientLastName}`,
    //       professionalRut: values.professionalRut,
    //       professionalName: values.professionalName,
    //       specialty: values.typeConsult,
    //       date: dateSchedule,
    //       timeStart: hourStartSchedule,
    //       timeEnd: hourEndSchedule,
    //       diagnosis: values.diagnosis.label,
    //       resume: values.resume,
    //       timeZone: values.timeZone
    //     };

    //     axios
    //       .post(`${urlServer}/resumeAtencion`, dataResume)
    //       .then((response) => {

    //         getIP().then((res) => {
    //           enviarLogNotifyResume(
    //             "[Resume] Send Medical Resume",
    //             response.data.message,
    //             values.professionalRut,
    //             values.professionalName,
    //             values.patientRut,
    //             values.patientName,
    //             values.patientLastName,
    //             res.data
    //           );
    //         });

    //       })
    //       .catch((error) => {
    //         errorAlert('No se pudo enviar el Resumen de la Atención, notificarlo al Área de TI');
    //         getIP().then((response) => {
    //           enviarLogErrorNotifyResume(
    //             "[Resume] Send Medical Resume",
    //             error.toString(),
    //             values.professionalRut,
    //             values.professionalName,
    //             values.patientRut,
    //             values.patientName,
    //             values.patientLastName,
    //             response.data
    //           );
    //         });

    //       });

    //     db.collection("professional")
    //       .where("rut", "==", values.professionalRut)
    //       .get()
    //       .then(function (querySnapshot) {
    //         querySnapshot.forEach(function (doc) {
    //           db.collection("professional")
    //             .doc(doc.data().uid)
    //             .update({
    //               patient: firebase.firestore.FieldValue.arrayUnion({
    //                 patientRut: data.patientRut,
    //                 patientName: `${data.patientName} ${data.patientLastName}`,
    //               }),
    //             });
    //         });
    //       });

    //     if (values.checked.length > 0) {
    //       const deriv = [];
    //       values.checked.forEach((value) => {
    //         deriv.push(value.value);
    //       });
    //       db.collection("referrals")
    //         .doc(values.idDocument)
    //         .set({
    //           derivaciones: deriv,
    //           idDocument: values.idDocument,
    //           patientEmail: values.patientEmail,
    //           patientLastName: values.patientLastName,
    //           patientName: values.patientName,
    //           patientPhone: values.patientPhone,
    //           patientRut: values.patientRut,
    //           professionalName: values.professionalName,
    //           professionalRut: values.professionalRut,
    //           state: "Por Contactar",
    //           timeStartAttention: values.startTimeTimestamp,
    //           description: values.descriptionDerivation,
    //         })
    //         .then(() => { })
    //         .catch((error) => {
    //           getIP().then((response) => {
    //             enviarLogErrorDoctorAddDerivations(
    //               "[Doctor] Add Derivations",
    //               error.toString(),
    //               values.professionalRut,
    //               values.professionalName,
    //               values.patientRut,
    //               values.patientName,
    //               values.patientLastName,
    //               values.idDocument,
    //               response.data
    //             );
    //           });
    //         });
    //     }

    //     db.collection("schedule")
    //       .doc(values.idDocument)
    //       .update({
    //         timeEnd: new Date(),
    //       });

    //     Swal.fire({
    //       position: "center",
    //       icon: "success",
    //       allowOutsideClick: false,
    //       title: "Se agregó la Ficha con Éxito",
    //       showConfirmButton: false,
    //       timer: 4000,
    //       showClass: {
    //         popup: "animate__animated animate__fadeInDown",
    //       },
    //       hideClass: {
    //         popup: "animate__animated animate__fadeOutUp",
    //       },
    //     });

    //     // let timerInterval
    //     // Swal.fire({
    //     // 	title: 'Auto Cierre!',
    //     // 	html: 'Esta ventaja se cerrará en <b></b> Milisegundos.',
    //     // 	timer: 4000,
    //     // 	timerProgressBar: true,
    //     // 	didOpen: () => {
    //     // 		Swal.showLoading()
    //     // 		const b = Swal.getHtmlContainer().querySelector('b')
    //     // 		timerInterval = setInterval(() => {
    //     // 			b.textContent = Swal.getTimerLeft()
    //     // 		}, 100)
    //     // 	},
    //     // 	willClose: () => {
    //     // 		clearInterval(timerInterval)
    //     // 	}
    //     // });
    //   })
    //   .catch((error) => {
    //     errorAlert('No se pudo agregar la Ficha con Éxito, notificarlo al Área de TI');
    //     getIP().then((response) => {
    //       enviarLogDoctorErrorAddRecord(
    //         types.doctorAddNewRecord,
    //         error.toString(),
    //         values.professionalRut,
    //         values.professionalName,
    //         values.patientName,
    //         values.patientLastName,
    //         values.idDocument,
    //         response.data
    //       );
    //     });
    //   });
  };
};

export const searchPatientsInProfessional = (
  values,
  data,
  fullNameLastNameActual,
  fullNameLastNameOld
) => {
  const reduxState = store.getState().company;
  const firebase = reduxState.companyInstance.firebase;
  const db = reduxState.companyInstance.db;

  db.collection("professional")
    .where("dni", "==", values.professionalDNI)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const patientsProfessional = doc.data().patient;
        let patientFind = "";

        if (patientsProfessional !== undefined) {
          patientFind = patientsProfessional.find(
            (patient) =>
              patient.patientDNI.trim().toUpperCase() ===
              data.patientDNI.trim().toUpperCase()
          );
        }

        if (patientFind !== "") {
          db.collection("professional")
            .doc(doc.data().uid)
            .update({
              patient: firebase.firestore.FieldValue.arrayUnion({
                patientDNI: data.patientDNI,
                patientName: `${data.patientName.trim()} ${data.patientLastName.trim()}`,
              }),
            });
        } else {
          if (fullNameLastNameActual !== fullNameLastNameOld) {
            db.collection("professional")
              .doc(doc.data().uid)
              .update({
                patient: firebase.firestore.FieldValue.arrayRemove(patientFind),
              })
              .then((res) => {
                db.collection("professional")
                  .doc(doc.data().uid)
                  .update({
                    patient: firebase.firestore.FieldValue.arrayUnion({
                      patientDNI: values.patientDNI.trim().toUpperCase(),
                      patientName: fullNameLastNameActual,
                    }),
                  });
              });
          }
        }
      });
    });
};

export const confirmationInformedConsent = (
  value,
  country,
  idDocument,
  patientDNI,
  timestamp
) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  db.collection("attention")
    .doc(country.replaceAll(" ", "").toLowerCase())
    .collection(patientDNI)
    .doc(timestamp.toString())
    .update({
      informedConfirmation: value,
    })
    .then(() => {
      db.collection(`schedule_${country.replaceAll(" ", "").toLowerCase()}`)
        .doc(idDocument)
        .update({
          informedConfirmation: value,
        });
    });
};
